// src/modules/admin/index.js
import React, { Component } from "react";
import "../../styles/admin.css";
import { API_ENDPOINTS, getRequest, postRequest } from "../../config/apiConfig";

/* ── Icons ──────────────────────────────────────────────────── */
const PATHS = {
  heartbeat: "M22 12h-4l-3 9L9 3l-3 9H2",
  calendar: "M3 4h18v18H3zM16 2v4M8 2v4M3 10h18",
  card: "M1 6h22v14H1zM1 10h22",
  user: "M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z",
  stethoscope: "M4.5 11.5A6 6 0 0016 8V4M9 4v4M4.5 11.5a6 6 0 009 5.5 6 6 0 006-6",
  bar: "M18 20V10M12 20V4M6 20v-6",
  qr: "M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h3v3h-3zM20 14v3M17 20h3M20 20v1",
  settings: "M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z",
  logout: "M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9",
  refresh: "M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15",
  clock:   "M12 22a10 10 0 100-20 10 10 0 000 20zM12 6v6l4 2",
  menu: "M3 12h18M3 6h18M3 18h18",
  bell: "M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0",
  chevron: "M9 18l6-6-6-6",
  plus: "M12 5v14M5 12h14",
  home: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z",
  doctor2: "M12 2a5 5 0 015 5v2a5 5 0 01-10 0V7a5 5 0 015-5zM2 22a10 10 0 0120 0",
  edit: "M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z",
  info: "M12 22a10 10 0 100-20 10 10 0 000 20zM12 8h.01M11 12h1v4h1",
  search: "M21 21l-4.35-4.35M17 11A6 6 0 115 11a6 6 0 0112 0z",
  eye: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 9a3 3 0 100 6 3 3 0 000-6z",
  phone: "M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z",
  mail: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zM22 6l-10 7L2 6",
  drop: "M12 2.69l5.66 5.66a8 8 0 11-11.31 0z",
};

class Ico extends Component {
  render() {
    const { name, size = 18, color = "currentColor", className = "" } = this.props;
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
        stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        className={className} style={{ flexShrink: 0 }}>
        <path d={PATHS[name] || PATHS.info} />
      </svg>
    );
  }
}

/* ── Demo Data ──────────────────────────────────────────────── */
const TODAY = "01 Apr 2026";

const APPOINTMENTS = [
  { id:"APT-2401", patient:"Raj Sharma",   dept:"Cardiology",   doctor:"Dr. Meena Kapoor", time:"10:00 AM", payment:"PAID",    channel:"ONLINE"  },
  { id:"APT-2402", patient:"Priya Verma",  dept:"Orthopaedics", doctor:"Dr. R. Kapoor",    time:"10:30 AM", payment:"PENDING", channel:"ONLINE"  },
  { id:"APT-2403", patient:"Anil Kumar",   dept:"General",      doctor:"Dr. A. Singh",     time:"11:00 AM", payment:"PAID",    channel:"ONLINE"  },
  { id:"APT-2404", patient:"Sunita Rao",   dept:"Cardiology",   doctor:"Dr. Meena Kapoor", time:"11:30 AM", payment:"PAID",    channel:"WALK-IN" },
  { id:"APT-2405", patient:"Vikram Joshi", dept:"Neurology",    doctor:"Dr. A. Patel",     time:"12:00 PM", payment:"PAID",    channel:"ONLINE"  },
];

const DEPARTMENTS = [
  { name:"Cardiology",   count:2, pct:57 },
  { name:"General",      count:2, pct:57 },
  { name:"Neurology",    count:2, pct:57 },
  { name:"Orthopaedics", count:1, pct:28 },
];

/* ── Badge ─────────────────────────────────────────────────── */
function Badge({ type }) {
  const map = {
    PAID:      { cls:"ad-badge-paid",    label:"PAID"    },
    PENDING:   { cls:"ad-badge-pending", label:"PENDING" },
    ONLINE:    { cls:"ad-badge-online",  label:"ONLINE"  },
    "WALK-IN": { cls:"ad-badge-walkin",  label:"WALK-IN" },
  };
  const m = map[type] || map["PAID"];
  return <span className={`ad-badge ${m.cls}`}>{m.label}</span>;
}

/* ════════════════════════════════════════════════════════════
   SIDEBAR
════════════════════════════════════════════════════════════ */
const MAIN_NAV = [
  { id:"dashboard",    label:"Dashboard",    icon:"home"        },
  { id:"appointments", label:"Appointments", icon:"calendar"    },
  { id:"patients",     label:"Patients",     icon:"user"        },
  { id:"doctors",      label:"Doctors",      icon:"stethoscope" },
  { id:"timeslots",    label:"Time Slots",   icon:"clock"        },
];

class Sidebar extends Component {
  render() {
    const { activePage, onNav, isOpen, onClose, onLogout } = this.props;
    let userName = "Admin User", initials = "AD";
    try {
      const raw = localStorage.getItem("dg_user");
      if (raw) {
        const u = JSON.parse(raw);
        if (u.name) {
          userName = u.name;
          initials = u.name.split(" ").filter(Boolean).slice(0,2).map(w=>w[0].toUpperCase()).join("");
        }
      }
    } catch(e) {}

    return (
      <>
        <div className={`ad-overlay${isOpen?" open":""}`} onClick={onClose} />
        <aside className={`ad-sidebar${isOpen?" open":""}`}>
          <div className="ad-logo">
            <div className="ad-logo-icon"><Ico name="heartbeat" size={18} color="#fff" /></div>
            <div>
              <div className="ad-logo-name">DG Doctor</div>
              <div className="ad-logo-sub">Hospital System</div>
            </div>
          </div>
          <div className="ad-user-badge">
            <div className="ad-user-avatar">{initials}</div>
            <div>
              <div className="ad-user-name">{userName}</div>
              <div className="ad-user-role">Administrator</div>
            </div>
          </div>
          <nav className="ad-nav">
            <span className="ad-nav-label">Menu</span>
            {MAIN_NAV.map(item => (
              <button key={item.id}
                className={`ad-nav-btn${activePage===item.id?" active":""}`}
                onClick={() => { onNav(item.id); onClose(); }}>
                <Ico name={item.icon} size={16}
                  color={activePage===item.id?"var(--ad-brand)":"var(--ad-text-3)"} />
                {item.label}
                {activePage===item.id && <div className="ad-nav-dot" />}
              </button>
            ))}
          </nav>
          <div className="ad-sidebar-bottom">
            <button className="ad-signout" onClick={onLogout}>
              <Ico name="logout" size={15} /> Sign out
            </button>
          </div>
        </aside>
      </>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   HEADER
════════════════════════════════════════════════════════════ */
class Header extends Component {
  render() {
    const { title, subtitle, onMenuClick } = this.props;
    let initials = "AU";
    try {
      const raw = localStorage.getItem("dg_user");
      if (raw) {
        const u = JSON.parse(raw);
        if (u.name) initials = u.name.split(" ").filter(Boolean).slice(0,2).map(w=>w[0].toUpperCase()).join("");
      }
    } catch(e) {}
    return (
      <header className="ad-header">
        <button className="ad-header-menu" onClick={onMenuClick}><Ico name="menu" size={20} /></button>
        <div>
          <div className="ad-header-title">{title}</div>
          {subtitle && <div className="ad-header-sub">{subtitle}</div>}
        </div>
        <div className="ad-header-right">
          <div className="ad-header-bell">
            <Ico name="bell" size={17} color="var(--ad-text-2)" />
            <div className="ad-bell-dot" />
          </div>
          <div className="ad-header-avatar">{initials}</div>
        </div>
      </header>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   DASHBOARD PAGE
════════════════════════════════════════════════════════════ */
class DashboardPage extends Component {
  constructor(props) {
    super(props);
    this.state = { appointments: [], loading: true, lastUpdated: null, countdown: 60 };
  }

  componentDidMount() {
    this.fetchAppointments();
    // Auto-refresh every 60 seconds
    this._timer     = setInterval(() => this.fetchAppointments(true), 60000);
    // Countdown tick
    this._countdown = setInterval(() => {
      this.setState(s => ({ countdown: s.countdown > 0 ? s.countdown - 1 : 60 }));
    }, 1000);
  }

  componentWillUnmount() {
    if (this._timer)     clearInterval(this._timer);
    if (this._countdown) clearInterval(this._countdown);
  }

  async fetchAppointments(silent = false) {
    if (!silent) this.setState({ loading: true });
    try {
      const res  = await getRequest(API_ENDPOINTS.ALL_APPOINTMENTS);
      const data = await res.json();
      let rows = [];
      if (data.status && Array.isArray(data.data) && Array.isArray(data.data[0])) rows = data.data[0];
      else if (Array.isArray(data.data)) rows = data.data;
      else if (Array.isArray(data))      rows = data;
      this.setState({ appointments: rows, loading: false, lastUpdated: new Date(), countdown: 60 });
    } catch (err) {
      this.setState({ loading: false });
    }
  }

  mapRow(a) {
    const rawStatus = (a.PaymentStatus || 'pending').toLowerCase();
    const isPaid    = rawStatus === 'paid' || rawStatus === 'completed';
    const date      = a.Appointmentdate || a.AppointmentDate || '';
    const fmtDate   = date ? new Date(date).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'}) : '—';
    return {
      id:      a.AppointmentID,
      patient: `${a.PatientFirstName||''} ${a.PatientLastName||''}`.trim() || `P-${a.PersonID}`,
      dept:    a.DepartmentName || '—',
      doctor:  `Dr. ${a.DoctorFirstName||''} ${a.DoctorLastName||''}`.trim(),
      time:    a.Time || '—',
      date:    fmtDate,
      status:  a.PaymentStatus || 'Pending',
      isPaid,
      qrType:  a.QR_Type || '—',
      reason:  a.Reason || '—',
      fees:    a.Payment != null ? `₹${a.Payment}` : '—',
    };
  }

  render() {
    const { appointments, loading } = this.state;
    const rows    = appointments.map(a => this.mapRow(a));
    const total   = rows.length;
    const paid    = rows.filter(r => r.isPaid).length;
    const pending = rows.filter(r => !r.isPaid).length;
    const official= rows.filter(r => r.qrType === 'Official QR').length;
    const temp    = rows.filter(r => r.qrType !== 'Official QR').length;

    // Dept distribution
    const deptMap = {};
    rows.forEach(r => { deptMap[r.dept] = (deptMap[r.dept]||0)+1; });
    const depts = Object.entries(deptMap).map(([name,count])=>({name,count,pct:total?Math.round(count/total*100):0})).sort((a,b)=>b.count-a.count);

    return (
      <div>
        <div className="ad-page-header ad-fade-up" style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:12,flexWrap:'wrap'}}>
          <div>
            <h1 className="ad-page-title">Dashboard</h1>
            <p className="ad-page-sub">Welcome back — {TODAY}</p>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
           
            <button className="ad-btn-add-doc" onClick={()=>this.props.onNav&&this.props.onNav('walkin')}><Ico name="plus" size={16} color="#fff" /> Register Walk-in Patient</button>
          </div>
          <div style={{display:'flex',alignItems:'center',gap:10,flexShrink:0}}>
            <div style={{fontSize:12,color:'var(--ad-text-3)',textAlign:'right'}}>
              {this.state.lastUpdated && <div>Updated {this.state.lastUpdated.toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'})}</div>}
              <div style={{color:'var(--ad-brand)',fontWeight:600}}>Next refresh in {this.state.countdown}s</div>
            </div>
            <button onClick={()=>this.fetchAppointments()} title="Refresh now"
              style={{width:34,height:34,borderRadius:10,border:'1.5px solid var(--ad-border)',background:'#fff',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
              <Ico name="refresh" size={15} color="var(--ad-brand)" />
            </button>
          </div>

          
        </div>

        {/* Stat cards — live from API */}
   
        <div className="ad-stats">
          <div className="ad-stat-card ad-fade-up">
            <div className="ad-stat-top">
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <div className="ad-stat-icon" style={{background:"var(--ad-brand-light)"}}>
                  <Ico name="calendar" size={18} color="var(--ad-brand)" />
                </div>
                <span className="ad-stat-label">Total<br/>Appointments</span>
              </div>
            </div>
            <div className="ad-stat-value">{loading ? '—' : total}</div>
            <div className="ad-stat-footer">{TODAY}</div>
          </div>
          <div className="ad-stat-card ad-fade-up-1">
            <div className="ad-stat-top">
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <div className="ad-stat-icon" style={{background:"var(--ad-accent-light)"}}>
                  <Ico name="card" size={18} color="var(--ad-accent)" />
                </div>
                <span className="ad-stat-label">Paid /<br/>Confirmed</span>
              </div>
            </div>
            <div className="ad-stat-value">{loading ? '—' : paid}</div>
            <div className="ad-stat-footer">{loading ? '' : `${pending} pending`}</div>
          </div>
          <div className="ad-stat-card ad-fade-up-2">
            <div className="ad-stat-top">
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <div className="ad-stat-icon" style={{background:"#FFF4EC"}}>
                  <Ico name="user" size={18} color="var(--ad-warn)" />
                </div>
                <span className="ad-stat-label">Pending<br/>Payments</span>
              </div>
            </div>
            <div className="ad-stat-value">{loading ? '—' : pending}</div>
            <div className="ad-stat-footer">{loading ? '' : `${paid} confirmed`}</div>
          </div>
          <div className="ad-stat-card ad-fade-up-3">
            <div className="ad-stat-top">
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <div className="ad-stat-icon" style={{background:"var(--ad-danger-light)"}}>
                  <Ico name="qr" size={18} color="var(--ad-danger)" />
                </div>
                <span className="ad-stat-label">QR Codes<br/>Issued</span>
              </div>
            </div>
            <div className="ad-stat-value">{loading ? '—' : total}</div>
            <div className="ad-stat-footer">{loading ? '' : `${temp} temporary`}</div>
          </div>
        </div>

        <div className="ad-dash-grid">
          {/* Recent Appointments — live from API */}
          <div className="ad-card ad-fade-up-1">
            <div className="ad-card-header">
              <div>
                <div className="ad-card-title">Recent Appointments</div>
                <div className="ad-card-subtitle">{loading ? 'Loading…' : `${total} total · ${paid} paid · ${pending} pending`}</div>
              </div>
              <button className="ad-view-all" onClick={() => this.props.onNav && this.props.onNav('appointments')}>
                <Ico name="chevron" size={14} color="var(--ad-brand)" /> View All
              </button>
            </div>
            <div style={{overflowX:"auto"}}>

              {/* Loading skeleton */}
              {loading && (
                <div>
                  {[1,2,3].map(n=>(
                    <div key={n} style={{display:'flex',gap:12,padding:'12px 16px',borderBottom:'1px solid var(--ad-border)',opacity:.45}}>
                      <div style={{width:48,height:11,background:'var(--ad-border)',borderRadius:6}} />
                      <div style={{flex:1}}><div style={{height:12,background:'var(--ad-border)',borderRadius:6,width:'50%',marginBottom:5}} /><div style={{height:10,background:'var(--ad-border)',borderRadius:6,width:'30%'}} /></div>
                      <div style={{width:80,height:11,background:'var(--ad-border)',borderRadius:6}} />
                      <div style={{width:60,height:24,background:'var(--ad-border)',borderRadius:20}} />
                    </div>
                  ))}
                </div>
              )}

              {!loading && rows.length === 0 && (
                <div style={{textAlign:'center',padding:'32px 16px',color:'var(--ad-text-3)',fontSize:13}}>No appointments found.</div>
              )}

              {!loading && rows.length > 0 && (
                <table className="ad-table">
                  <thead>
                    <tr>
                      <th>ID</th><th>Patient</th><th>Department</th>
                      <th>Doctor</th><th>Date · Time</th><th>Fees</th><th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map(row => (
                      <tr key={row.id}>
                        <td><span style={{fontFamily:'monospace',fontWeight:700,color:'var(--ad-brand)',fontSize:12}}>#{row.id}</span></td>
                        <td><div style={{fontWeight:600,fontSize:13}}>{row.patient}</div></td>
                        <td style={{color:'var(--ad-text-2)',fontSize:12}}>{row.dept}</td>
                        <td style={{color:'var(--ad-text-2)',fontSize:12}}>{row.doctor}</td>
                        <td style={{color:'var(--ad-text-2)',fontSize:12}}>{row.date}<br/><span style={{color:'var(--ad-text-3)'}}>{row.time}</span></td>
                        <td style={{fontWeight:700,fontSize:13}}>{row.fees}</td>
                        <td>
                          <span style={{fontSize:11,fontWeight:700,padding:'4px 9px',borderRadius:20,
                            background: row.isPaid?'#E6FAF5':'#FFF0EB',
                            color:      row.isPaid?'#059669':'#FF6B35'}}>
                            {row.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          <div>
           
            <div className="ad-card ad-fade-up-3">
              <div className="ad-card-header"><div className="ad-card-title">Quick Actions</div></div>
              <div className="ad-card-body">
                <button className="ad-qa-primary" onClick={()=>this.props.onNav&&this.props.onNav('walkin')}><Ico name="plus" size={16} color="#fff" /> Register Walk-in Patient</button>
                <button className="ad-qa-btn" onClick={() => this.props.onNav && this.props.onNav('appointments')}><Ico name="calendar" size={15} color="var(--ad-text-3)" /> View All Appointments</button>
                <button className="ad-qa-btn" onClick={() => this.props.onNav && this.props.onNav('doctors')}><Ico name="stethoscope" size={15} color="var(--ad-text-3)" /> Doctor Management</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   DOCTORS PAGE  — GET /api/doctors/getdoctorlist
   API shape: DoctorID, FirstName, MiddleName, LastName,
              Specilization, DepartmentName, OPD_Time,
              OPD_Fees, Status, DoctorCode, Gender, City
════════════════════════════════════════════════════════════ */
const DOCTORS_FALLBACK = [
  { id:"D1", initials:"MK", name:"Dr. Meena Kapoor", qual:"MD, DM Cardiology",  dept:"CARDIOLOGY",   slots:5, available:["9:00 AM","10:00 AM","11:00 AM","12:00 PM","2:00 PM"],                extraLabel:"+2 more", doctorCode:"", fees:"", status:"Active", gender:"", city:"" },
  { id:"D2", initials:"RK", name:"Dr. R. Kapoor",    qual:"MS Orthopaedics",    dept:"ORTHOPAEDICS", slots:4, available:["9:30 AM","10:30 AM","11:30 AM","1:00 PM"],                           extraLabel:"+1 more", doctorCode:"", fees:"", status:"Active", gender:"", city:"" },
  { id:"D3", initials:"AS", name:"Dr. A. Singh",     qual:"MBBS, MD General",   dept:"GENERAL",      slots:6, available:["9:00 AM","10:00 AM","11:00 AM","12:00 PM","2:00 PM","3:00 PM"],       extraLabel:"+3 more", doctorCode:"", fees:"", status:"Active", gender:"", city:"" },
  { id:"D4", initials:"AP", name:"Dr. A. Patel",     qual:"MD, DM Neurology",   dept:"NEUROLOGY",    slots:4, available:["10:00 AM","11:00 AM","12:00 PM","2:00 PM"],                          extraLabel:"+1 more", doctorCode:"", fees:"", status:"Active", gender:"", city:"" },
  { id:"D5", initials:"SV", name:"Dr. S. Verma",     qual:"MD Paediatrics",     dept:"PAEDIATRICS",  slots:3, available:["9:00 AM","10:00 AM","11:00 AM"],                                     extraLabel:null,      doctorCode:"", fees:"", status:"Active", gender:"", city:"" },
];

function mapDoctor(raw, idx) {
  const nameParts = [raw.FirstName, raw.MiddleName, raw.LastName].filter(Boolean);
  const fullName  = nameParts.length > 0 ? `Dr. ${nameParts.join(" ")}` : `Doctor ${idx + 1}`;
  const qual      = raw.Specilization || raw.Specialization || "";
  const dept      = (raw.DepartmentName || raw.Department || "GENERAL").toUpperCase();

  // OPD_Time "09:00-12:00" → parse into 30-min slots
  const newavailable = [];
  if (raw.OPD_Time) {
    const [startStr, endStr] = raw.OPD_Time.split("-");
    if (startStr && endStr) {
      const toMins = t => { const [h,m] = t.trim().split(":").map(Number); return h*60+(m||0); };
      const fmt = mins => {
        const h=Math.floor(mins/60), m=mins%60, ampm=h>=12?"PM":"AM";
        const h12=h>12?h-12:h===0?12:h;
        return `${h12}:${String(m).padStart(2,"0")} ${ampm}`;
      };
      let cur=toMins(startStr); const end=toMins(endStr);
      while(cur<end){ newavailable.push(fmt(cur)); cur+=30; }
    }
  }

  const initials   = [raw.FirstName,raw.LastName].filter(Boolean).map(w=>w[0].toUpperCase()).join("");
  const slots      = newavailable.length;
  const extraLabel = newavailable.length > 3 ? `+${newavailable.length-3} more` : null;

  // Format DOB "1975-03-14T18:30:00.000Z" → "YYYY-MM-DD" for date input
  const rawDob = raw.DOB || raw.DateOfBirth || '';
  const dob    = rawDob ? rawDob.split('T')[0] : '';

  return {
    id:           String(raw.DoctorID || idx),
    initials,
    name:         fullName,
    qual,
    dept,
    slots,
    available:    newavailable,
    extraLabel,
    doctorCode:   raw.DoctorCode     || "",
    fees:         raw.OPD_Fees       || "",
    status:       raw.Status         || "Active",
    gender:       raw.Gender         || "",
    city:         raw.City           || "",
    // Raw fields for edit form pre-fill
    raw_firstName:    raw.FirstName    || "",
    raw_middleName:   raw.MiddleName   || "",
    raw_lastName:     raw.LastName     || "",
    raw_gender:       raw.Gender       || "",
    raw_dob:          dob,
    raw_bloodGroup:   raw.BloodGroup   || "",
    raw_doctorCode:   raw.DoctorCode   || "",
    raw_specialization: raw.Specilization || raw.Specialization || "",
    raw_fees:         raw.OPD_Fees     || "",
    raw_opdTime:      raw.OPD_Time     || "",
    raw_departmentId: String(raw.DepartmentID || ""),
    raw_departmentName: raw.DepartmentName || "",
    raw_personId:     String(raw.PersonID || ""),
  };
}

function formatSlots(available, extraLabel) {
  const shown = available.slice(0,3).join(" · ");
  return extraLabel ? `${shown} ${extraLabel}` : shown;
}

/* ── DoctorsPage form helpers — module level to prevent focus loss ── */
function DOC_F({label, req, err, children}) {
  return (
    <div style={{marginBottom:14}}>
      <label style={{fontSize:12,fontWeight:600,color:'var(--ad-text-2)',display:'block',marginBottom:5}}>
        {label}{req&&<span style={{color:'#ef4444',marginLeft:2}}>*</span>}
      </label>
      {children}
      {err && <div style={{fontSize:11,color:'#ef4444',marginTop:3}}>{err}</div>}
    </div>
  );
}
function DOC_iS(hasErr) {
  return {
    width:'100%', height:42, borderRadius:10,
    border:`1.5px solid ${hasErr?'#ef4444':'var(--ad-border)'}`,
    padding:'0 12px', fontSize:14, fontFamily:'inherit',
    outline:'none', boxSizing:'border-box',
  };
}
function DOC_sS(hasErr) {
  return { ...DOC_iS(hasErr), background:'#fff' };
}

class DoctorsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      doctors:[], loading:true, error:null,
      showModal: false,
      saving: false, saveError: null, saveSuccess: false,
      departments: [],   // loaded from doctor list API
      form: {
        firstName:'', middleName:'', lastName:'', gender:'',
        dob:'', bloodGroup:'',
        doctorCode:'', specialization:'', fees:'', opdTime:'09:00-13:00',
        departmentId:'', departmentName:'',
      },
      formErrors: {},
      // Edit
      showEdit: false, editDoc: null, editForm: {},
      editErrors: {}, editSaving: false, editSaveError: null, editSaveSuccess: false,
    };
  }
  componentDidMount() { this.fetchDoctors(); this.fetchDepartments(); }

  async fetchDepartments() {
    this.setState({ deptsLoading: true });
    try {
      const res  = await getRequest(API_ENDPOINTS.DEPARTMENT_LIST);
      const data = await res.json();
      console.log('Departments raw:', data);
      let rows = [];
      if (Array.isArray(data.data?.Department))                rows = data.data.Department;
      else if (data.status && Array.isArray(data.data?.[0]))   rows = data.data[0];
      else if (Array.isArray(data.data))                       rows = data.data;
      else if (Array.isArray(data))                            rows = data;
      this.setState({ departments: rows, deptsLoading: false });
    } catch(err) {
      console.warn('Departments fetch failed:', err.message);
      this.setState({ deptsLoading: false });
    }
  }

  async fetchDoctors() {
    this.setState({ loading:true, error:null });
    try {
      const res  = await getRequest(API_ENDPOINTS.DOCTOR_LIST);
      const data = await res.json();
      let rows = [];
      if (Array.isArray(data.data?.Doctor))               rows = data.data.Doctor;
      else if (data.status && Array.isArray(data.data?.[0])) rows = data.data[0];
      else if (Array.isArray(data.data))                  rows = data.data;
      this.setState({ doctors: rows.length>0 ? rows.map(mapDoctor) : DOCTORS_FALLBACK, loading:false });
    } catch(err) {
      this.setState({ doctors:DOCTORS_FALLBACK, loading:false, error:err.message });
    }
  }

  setForm(k, v) {
    this.setState(s => ({ form:{...s.form,[k]:v}, formErrors:{...s.formErrors,[k]:''} }));
  }

  validateForm() {
    const { form } = this.state;
    const e = {};
    if (!form.firstName.trim())      e.firstName      = 'Required';
    if (!form.lastName.trim())       e.lastName       = 'Required';
    if (!form.gender)                e.gender         = 'Required';
    if (!form.dob)                   e.dob            = 'Required';
    if (!form.bloodGroup)            e.bloodGroup     = 'Required';
    if (!form.doctorCode.trim())     e.doctorCode     = 'Required';
    if (!form.departmentId)          e.departmentId   = 'Required';
    if (!form.specialization.trim()) e.specialization = 'Required';
    if (!form.fees.toString().trim())e.fees           = 'Required';
    if (!form.opdTime.trim())        e.opdTime        = 'Required';
    console.log('Validation errors:', e, '| Form:', form);
    return e;
  }

  async saveDoctor() {
    const errs = this.validateForm();
    if (Object.keys(errs).length > 0) {
      this.setState({ formErrors: errs });
      // Show which fields failed in modal
      const missing = Object.keys(errs).join(', ');
      this.setState({ saveError: `Please fill required fields: ${missing}` });
      return;
    }
    this.setState({ saveError: null });
    const { form } = this.state;
    this.setState({ saving:true, saveError:null });
    const raw = localStorage.getItem("dg_user");
      
    const u = JSON.parse(raw);
    try {
      const payload = {
        FirstName:      form.firstName,
        MiddleName:     form.middleName,
        LastName:       form.lastName,
        Gender:         form.gender,
        DOB:            form.dob,
        BloodGroup:     form.bloodGroup,
        DoctorCode:     form.doctorCode,
        DepartmentName: form.department,
        Specialization:  form.specialization,
        OPD_Fees:       String(form.fees),
        OPD_Time:       form.opdTime,
        DepartmentID:   form.departmentId,
        DepartmentName: form.departmentName,
        Status:         'Active',
        CreatedBy:      u.personId
      };
      console.log('Add doctor payload:', payload);
      const res  = await postRequest(API_ENDPOINTS.DOCTOR_ADD, payload);
      const data = await res.json();
      console.log('Add doctor response:', data);
      if (data.status === false || data.success === false) {
        this.setState({ saving:false, saveError: data.message || JSON.stringify(data) });
        return;
      }
      this.setState({ saving:false, saveSuccess:true });
      setTimeout(() => {
        this.setState({ showModal:false, saveSuccess:false, form:{ firstName:'',middleName:'',lastName:'',gender:'',dob:'',bloodGroup:'',doctorCode:'',specialization:'',fees:'',opdTime:'09:00-13:00',departmentId:'',departmentName:'' } });
        this.fetchDoctors();
      }, 1500);
    } catch(err) {
      this.setState({ saving:false, saveError:err.message });
    }
  }

  openEdit(doc) {
    this.setState({
      showEdit: true, editDoc: doc, editSaveError: null, editSaveSuccess: false, editErrors: {},
      editForm: {
        firstName:      doc.raw_firstName,
        middleName:     doc.raw_middleName,
        lastName:       doc.raw_lastName,
        gender:         doc.raw_gender,
        dob:            doc.raw_dob,
        bloodGroup:     doc.raw_bloodGroup,
        doctorCode:     doc.raw_doctorCode,
        specialization: doc.raw_specialization,
        fees:           doc.raw_fees,
        opdTime:        doc.raw_opdTime,
        departmentId:   String(doc.raw_departmentId || ''),
        departmentName: doc.raw_departmentName || '',
      },
    });
  }

  async saveEdit() {
    const { editForm, editDoc } = this.state;
    const e = {};
    if (!editForm.firstName.trim()) e.firstName = 'Required';
    if (!editForm.lastName.trim())  e.lastName  = 'Required';
    if (!editForm.fees.toString().trim()) e.fees = 'Required';
    if (Object.keys(e).length > 0) { this.setState({ editErrors: e, editSaveError: `Fill required: ${Object.keys(e).join(', ')}` }); return; }

    this.setState({ editSaving: true, editSaveError: null });
    try {
      const payload = {
        DoctorID:       editDoc.id,
        PersonID:       editDoc.raw_personId,
        FirstName:      editForm.firstName,
        MiddleName:     editForm.middleName,
        LastName:       editForm.lastName,
        Gender:         editForm.gender,
        DOB:            editForm.dob,
        BloodGroup:     editForm.bloodGroup,
        DoctorCode:     editForm.doctorCode,
        Specilization:  editForm.specialization,
        OPD_Fees:       String(editForm.fees),
        OPD_Time:       editForm.opdTime,
        DepartmentID:   editForm.departmentId,
        DepartmentName: editForm.departmentName,
        Status:         'Active',
      };
      console.log('Edit doctor payload:', payload);
      const res  = await postRequest(API_ENDPOINTS.DOCTOR_UPDATE, payload);
      const data = await res.json();
      console.log('Edit doctor response:', data);
      this.setState({ editSaving: false, editSaveSuccess: true });
      setTimeout(() => {
        this.setState({ showEdit: false, editSaveSuccess: false });
        this.fetchDoctors();
      }, 1500);
    } catch(err) {
      this.setState({ editSaving: false, editSaveError: err.message });
    }
  }

  render() {
    const { doctors, loading, error, showModal, saving, saveError, saveSuccess, form, formErrors, departments,
            showEdit, editForm, editErrors, editSaving, editSaveError, editSaveSuccess } = this.state;

    // helpers defined at module level as DOC_F, DOC_iS, DOC_sS

    return (
      <div>
        <div className="ad-doctors-header ad-fade-up">
          <div>
            <h1 className="ad-page-title">Doctors</h1>
            <p className="ad-page-sub">{loading?"Loading…":`${doctors.length} active doctors`}</p>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            {error && !loading && (
              <button onClick={()=>this.fetchDoctors()} style={{padding:"9px 16px",border:"1.5px solid var(--ad-border)",borderRadius:10,background:"transparent",cursor:"pointer",fontSize:13,fontWeight:600,color:"var(--ad-text-2)",fontFamily:"var(--ad-font-body)"}}>↺ Retry</button>
            )}
            <button className="ad-btn-add-doc" onClick={()=>this.setState({showModal:true,saveError:null,saveSuccess:false})}><Ico name="plus" size={16} color="#fff" /> Add Doctor</button>
          </div>
        </div>

        {/* ── Add Doctor Modal ── */}
        {showModal && (
          <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:16}} onClick={e=>{if(e.target===e.currentTarget)this.setState({showModal:false})}}>
            <div style={{background:'#fff',borderRadius:20,width:'100%',maxWidth:600,maxHeight:'90vh',overflowY:'auto',boxShadow:'0 20px 60px rgba(0,0,0,.2)'}}>

              {/* Modal header */}
              <div style={{padding:'20px 24px',borderBottom:'1px solid var(--ad-border)',display:'flex',alignItems:'center',justifyContent:'space-between',position:'sticky',top:0,background:'#fff',borderRadius:'20px 20px 0 0',zIndex:1}}>
                <div>
                  <div style={{fontWeight:800,fontSize:17,color:'var(--ad-text-1)'}}>Add New Doctor</div>
                  <div style={{fontSize:12,color:'var(--ad-text-3)',marginTop:2}}>Fill in the doctor's details</div>
                </div>
                <button onClick={()=>this.setState({showModal:false})} style={{width:32,height:32,borderRadius:8,border:'1.5px solid var(--ad-border)',background:'#fff',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,color:'var(--ad-text-3)'}}>✕</button>
              </div>

              {/* Modal body */}
              <div style={{padding:24}}>
                {saveSuccess && (
                  <div style={{background:'#F0FDF4',border:'1px solid #a7f3d0',borderRadius:12,padding:'12px 16px',marginBottom:16,display:'flex',alignItems:'center',gap:8,fontSize:14,color:'#059669',fontWeight:600}}>
                    ✓ Doctor added successfully! Refreshing list…
                  </div>
                )}
                {saveError && (
                  <div style={{background:'#FFF0EB',border:'1px solid #fcd9c4',borderRadius:12,padding:'12px 16px',marginBottom:16,fontSize:13,color:'#ef4444'}}>
                    Error: {saveError}
                  </div>
                )}

                {/* Personal */}
                <div style={{fontWeight:700,fontSize:12,color:'var(--ad-text-3)',textTransform:'uppercase',letterSpacing:.5,marginBottom:12,paddingBottom:8,borderBottom:'1px solid var(--ad-border)'}}>👤 Personal Details</div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12,marginBottom:12}}>
                  <DOC_F label="First Name" req err={formErrors.firstName}>
                    <input style={DOC_iS(!!formErrors.firstName)} placeholder="First" value={form.firstName} onChange={e=>this.setForm('firstName',e.target.value)} />
                  </DOC_F>
                  <DOC_F label="Middle Name">
                    <input style={DOC_iS(false)} placeholder="Middle (optional)" value={form.middleName} onChange={e=>this.setForm('middleName',e.target.value)} />
                  </DOC_F>
                  <DOC_F label="Last Name" req err={formErrors.lastName}>
                    <input style={DOC_iS(!!formErrors.lastName)} placeholder="Last" value={form.lastName} onChange={e=>this.setForm('lastName',e.target.value)} />
                  </DOC_F>
                </div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12,marginBottom:12}}>
                  <DOC_F label="Gender" req err={formErrors.gender}>
                    <select style={DOC_sS(!!formErrors.gender)} value={form.gender} onChange={e=>this.setForm('gender',e.target.value)}>
                      <option value="">Select</option>
                      <option>Male</option><option>Female</option><option>Other</option>
                    </select>
                  </DOC_F>
                  <DOC_F label="Date of Birth" req err={formErrors.dob}>
                    <input type="date" style={DOC_iS(!!formErrors.dob)} value={form.dob} onChange={e=>this.setForm('dob',e.target.value)} />
                  </DOC_F>
                  <DOC_F label="Blood Group" req err={formErrors.bloodGroup}>
                    <select style={DOC_sS(!!formErrors.bloodGroup)} value={form.bloodGroup} onChange={e=>this.setForm('bloodGroup',e.target.value)}>
                      <option value="">Select</option>
                      {['A+','A-','B+','B-','AB+','AB-','O+','O-'].map(b=><option key={b}>{b}</option>)}
                    </select>
                  </DOC_F>
                </div>

                {/* Professional */}
                <div style={{fontWeight:700,fontSize:12,color:'var(--ad-text-3)',textTransform:'uppercase',letterSpacing:.5,margin:'4px 0 12px',paddingBottom:8,borderBottom:'1px solid var(--ad-border)'}}>🏥 Professional Details</div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
                  <DOC_F label="Doctor Code" req err={formErrors.doctorCode}>
                    <input style={DOC_iS(!!formErrors.doctorCode)} placeholder="e.g. DG-DOC-00013" value={form.doctorCode} onChange={e=>this.setForm('doctorCode',e.target.value)} />
                  </DOC_F>
                  <DOC_F label="Scanner URL (auto)">
                    <div style={{...DOC_iS(false), display:'flex', alignItems:'center', background:'#f8fafc', cursor:'default', overflow:'hidden', fontSize:12, color:'var(--ad-text-3)', paddingRight:8}}>
                      <span style={{flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>
                        {form.doctorCode ? `${window.location.origin}/doctorScan?id=${form.doctorCode}` : 'Enter Doctor Code first'}
                      </span>
                      {form.doctorCode && (
                        <button type="button" onClick={()=>{
                          navigator.clipboard?.writeText(`${window.location.origin}/doctorScan?id=${form.doctorCode}`)
                            .then(()=>alert('URL copied!'))
                            .catch(()=>{});
                        }} style={{flexShrink:0,border:'none',background:'var(--ad-brand)',color:'#fff',borderRadius:6,padding:'3px 8px',fontSize:11,fontWeight:700,cursor:'pointer',fontFamily:'inherit'}}>
                          Copy
                        </button>
                      )}
                    </div>
                  </DOC_F>
                  <DOC_F label="Department" req err={formErrors.departmentId}>
                    <select style={DOC_sS(!!formErrors.departmentId)} value={form.departmentId}
                      onChange={e => {
                        const val = e.target.value;
                        const sel = departments.find((d, idx) =>
                          String(d?.DepartmentID ?? d?.departmentId ?? d?.id ?? idx) === val
                        );
                        const name = sel ? (sel?.DepartmentName ?? sel?.departmentName ?? sel?.name ?? val) : val;
                        this.setForm('departmentId',   val);
                        this.setForm('departmentName', name);
                      }}>
                      <option value="">— Select Department —</option>
                      {departments.map((d, idx) => {
                        // Handle any response shape
                        const id   = d?.DepartmentID ?? d?.departmentId ?? d?.id ?? d?.ID ?? idx;
                        const name = d?.DepartmentName ?? d?.departmentName ?? d?.name ?? d?.Name ?? String(d);
                        return (
                          <option key={String(id) + '_' + idx} value={String(id)}>
                            {name}
                          </option>
                        );
                      })}
                    </select>
                  </DOC_F>
                  <DOC_F label="Specialization" req err={formErrors.specialization}>
                    <input style={DOC_iS(!!formErrors.specialization)} placeholder="e.g. Interventional Cardiology" value={form.specialization} onChange={e=>this.setForm('specialization',e.target.value)} />
                  </DOC_F>
                  <DOC_F label="OPD Fees (₹)" req err={formErrors.fees}>
                    <input type="number" style={DOC_iS(!!formErrors.fees)} placeholder="500" value={form.fees} onChange={e=>this.setForm('fees',e.target.value)} />
                  </DOC_F>
                  <DOC_F label="OPD Time" req err={formErrors.opdTime}>
                    <input style={DOC_iS(!!formErrors.opdTime)} placeholder="09:00-13:00" value={form.opdTime} onChange={e=>this.setForm('opdTime',e.target.value)} />
                  </DOC_F>
                </div>
              </div>

              {/* Modal footer */}
              <div style={{padding:'16px 24px',borderTop:'1px solid var(--ad-border)',display:'flex',justifyContent:'flex-end',gap:10,position:'sticky',bottom:0,background:'#fff',borderRadius:'0 0 20px 20px'}}>
                <button onClick={()=>this.setState({showModal:false})} style={{padding:'10px 24px',borderRadius:10,border:'1.5px solid var(--ad-border)',background:'#fff',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:'inherit',color:'var(--ad-text-1)'}}>
                  Cancel
                </button>
                <button onClick={()=>this.saveDoctor()} disabled={saving}
                  style={{padding:'10px 28px',borderRadius:10,border:'none',background:'var(--ad-brand)',color:'#fff',fontSize:14,fontWeight:700,cursor:'pointer',fontFamily:'inherit',opacity:saving?0.7:1}}>
                  {saving ? 'Saving…' : '+ Add Doctor'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Edit Doctor Modal ── */}
        {showEdit && (
          <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:16}} onClick={e=>{if(e.target===e.currentTarget)this.setState({showEdit:false})}}>
            <div style={{background:'#fff',borderRadius:20,width:'100%',maxWidth:600,maxHeight:'90vh',overflowY:'auto',boxShadow:'0 20px 60px rgba(0,0,0,.2)'}}>
              <div style={{padding:'20px 24px',borderBottom:'1px solid var(--ad-border)',display:'flex',alignItems:'center',justifyContent:'space-between',position:'sticky',top:0,background:'#fff',borderRadius:'20px 20px 0 0',zIndex:1}}>
                <div>
                  <div style={{fontWeight:800,fontSize:17,color:'var(--ad-text-1)'}}>Edit Doctor</div>
                  <div style={{fontSize:12,color:'var(--ad-text-3)',marginTop:2}}>{this.state.editDoc?.name}</div>
                </div>
                <button onClick={()=>this.setState({showEdit:false})} style={{width:32,height:32,borderRadius:8,border:'1.5px solid var(--ad-border)',background:'#fff',cursor:'pointer',fontSize:18,color:'var(--ad-text-3)'}}>✕</button>
              </div>
              <div style={{padding:24}}>
                {editSaveSuccess && <div style={{background:'#F0FDF4',border:'1px solid #a7f3d0',borderRadius:12,padding:'12px 16px',marginBottom:16,fontSize:14,color:'#059669',fontWeight:600}}>✓ Doctor updated successfully!</div>}
                {editSaveError  && <div style={{background:'#FFF0EB',border:'1px solid #fcd9c4',borderRadius:12,padding:'12px 16px',marginBottom:16,fontSize:13,color:'#ef4444'}}>{editSaveError}</div>}

                <div style={{fontWeight:700,fontSize:12,color:'var(--ad-text-3)',textTransform:'uppercase',letterSpacing:.5,marginBottom:12,paddingBottom:8,borderBottom:'1px solid var(--ad-border)'}}>👤 Personal Details</div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12,marginBottom:12}}>
                  <DOC_F label="First Name" req err={editErrors.firstName}>
                    <input style={DOC_iS(!!editErrors.firstName)} value={editForm.firstName||''} onChange={e=>this.setState(s=>({editForm:{...s.editForm,firstName:e.target.value},editErrors:{...s.editErrors,firstName:''}}))} />
                  </DOC_F>
                  <DOC_F label="Middle Name">
                    <input style={DOC_iS(false)} value={editForm.middleName||''} onChange={e=>this.setState(s=>({editForm:{...s.editForm,middleName:e.target.value}}))} />
                  </DOC_F>
                  <DOC_F label="Last Name" req err={editErrors.lastName}>
                    <input style={DOC_iS(!!editErrors.lastName)} value={editForm.lastName||''} onChange={e=>this.setState(s=>({editForm:{...s.editForm,lastName:e.target.value},editErrors:{...s.editErrors,lastName:''}}))} />
                  </DOC_F>
                </div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12,marginBottom:12}}>
                  <DOC_F label="Gender">
                    <select style={DOC_sS(false)} value={editForm.gender||''} onChange={e=>this.setState(s=>({editForm:{...s.editForm,gender:e.target.value}}))}>
                      <option value="">Select</option><option>Male</option><option>Female</option><option>Other</option>
                    </select>
                  </DOC_F>
                  <DOC_F label="Date of Birth">
                    <input type="date" style={DOC_iS(false)} value={editForm.dob||''} onChange={e=>this.setState(s=>({editForm:{...s.editForm,dob:e.target.value}}))} />
                  </DOC_F>
                  <DOC_F label="Blood Group">
                    <select style={DOC_sS(false)} value={editForm.bloodGroup||''} onChange={e=>this.setState(s=>({editForm:{...s.editForm,bloodGroup:e.target.value}}))}>
                      <option value="">Select</option>
                      {['A+','A-','B+','B-','AB+','AB-','O+','O-'].map(b=><option key={b}>{b}</option>)}
                    </select>
                  </DOC_F>
                </div>

                <div style={{fontWeight:700,fontSize:12,color:'var(--ad-text-3)',textTransform:'uppercase',letterSpacing:.5,margin:'4px 0 12px',paddingBottom:8,borderBottom:'1px solid var(--ad-border)'}}>🏥 Professional Details</div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                  <DOC_F label="Doctor Code">
                    <input style={DOC_iS(false)} value={editForm.doctorCode||''} onChange={e=>this.setState(s=>({editForm:{...s.editForm,doctorCode:e.target.value}}))} />
                  </DOC_F>
                  <DOC_F label="Department">
                    <select style={DOC_sS(false)} value={editForm.departmentId||''}
                      onChange={e=>{
                        const sel = departments.find((d,i)=>String(d?.DepartmentID??d?.id??i)===e.target.value);
                        this.setState(s=>({editForm:{...s.editForm,
                          departmentId:   e.target.value,
                          departmentName: sel?.DepartmentName??sel?.name??e.target.value,
                        }}));
                      }}>
                      <option value="">— Select Department —</option>
                      {departments.map((d,i)=>{
                        const id   = String(d?.DepartmentID??d?.id??i);
                        const name = d?.DepartmentName??d?.name??String(d);
                        return <option key={id+'_'+i} value={id}>{name}</option>;
                      })}
                    </select>
                  </DOC_F>
                  <DOC_F label="Specialization">
                    <input style={DOC_iS(false)} value={editForm.specialization||''} onChange={e=>this.setState(s=>({editForm:{...s.editForm,specialization:e.target.value}}))} />
                  </DOC_F>
                  <DOC_F label="OPD Fees (₹)" req err={editErrors.fees}>
                    <input type="number" style={DOC_iS(!!editErrors.fees)} value={editForm.fees||''} onChange={e=>this.setState(s=>({editForm:{...s.editForm,fees:e.target.value},editErrors:{...s.editErrors,fees:''}}))} />
                  </DOC_F>
                  <DOC_F label="OPD Time">
                    <input style={DOC_iS(false)} placeholder="09:00-13:00" value={editForm.opdTime||''} onChange={e=>this.setState(s=>({editForm:{...s.editForm,opdTime:e.target.value}}))} />
                  </DOC_F>
                </div>
              </div>
              <div style={{padding:'16px 24px',borderTop:'1px solid var(--ad-border)',display:'flex',justifyContent:'flex-end',gap:10,position:'sticky',bottom:0,background:'#fff',borderRadius:'0 0 20px 20px'}}>
                <button onClick={()=>this.setState({showEdit:false})} style={{padding:'10px 24px',borderRadius:10,border:'1.5px solid var(--ad-border)',background:'#fff',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:'inherit',color:'var(--ad-text-1)'}}>Cancel</button>
                <button onClick={()=>this.saveEdit()} disabled={editSaving}
                  style={{padding:'10px 28px',borderRadius:10,border:'none',background:'var(--ad-brand)',color:'#fff',fontSize:14,fontWeight:700,cursor:'pointer',fontFamily:'inherit',opacity:editSaving?0.7:1}}>
                  {editSaving ? 'Saving…' : '✓ Save Changes'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Loading skeleton */}
        {loading && (
          <div className="ad-doctors-grid">
            {[1,2,3,4,5].map(n=>(
              <div key={n} className="ad-doc-card" style={{opacity:.5}}>
                <div className="ad-doc-head">
                  <div className="ad-doc-avatar" style={{background:"var(--ad-border)"}} />
                  <div style={{flex:1}}>
                    <div style={{height:14,background:"var(--ad-border)",borderRadius:6,marginBottom:6,width:"70%"}} />
                    <div style={{height:11,background:"var(--ad-border)",borderRadius:6,width:"50%"}} />
                  </div>
                </div>
                <div style={{height:10,background:"var(--ad-border)",borderRadius:6,marginBottom:10,width:"60%"}} />
                <div style={{height:10,background:"var(--ad-border)",borderRadius:6,marginBottom:14,width:"90%"}} />
                <div style={{display:"flex",gap:8}}>
                  <div style={{flex:1,height:36,background:"var(--ad-border)",borderRadius:10}} />
                  <div style={{width:60,height:36,background:"var(--ad-border)",borderRadius:10}} />
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Cards grid */}
        {!loading && (
          <div className="ad-doctors-grid">
            {doctors.map((doc,i)=>(
              <div key={doc.id} className={`ad-doc-card ad-fade-up-${Math.min(i,4)}`}>
                <div className="ad-doc-head">
                  <div className="ad-doc-avatar">{doc.initials}</div>
                  <div style={{flex:1,minWidth:0}}>
                    <div className="ad-doc-name">{doc.name}</div>
                    <div className="ad-doc-qual">{doc.qual}</div>
                    {doc.doctorCode && <div style={{fontSize:10,color:"var(--ad-text-3)",fontFamily:"monospace",marginTop:2}}>{doc.doctorCode}</div>}
                  </div>
                  <span style={{fontSize:10,fontWeight:700,padding:"3px 8px",borderRadius:20,flexShrink:0,alignSelf:"flex-start",background:doc.status==="Active"?"var(--ad-accent-light)":"#F1F5F9",color:doc.status==="Active"?"#059669":"var(--ad-text-3)"}}>{doc.status}</span>
                </div>
                <div className="ad-doc-tags">
                  <span className="ad-doc-dept-tag">{doc.dept}</span>
                  <span className="ad-doc-slots-tag">{doc.slots} SLOTS</span>
                  {doc.fees && <span style={{fontSize:10,fontWeight:700,padding:"4px 9px",borderRadius:20,background:"#FFF4EC",color:"var(--ad-warn)",border:"1px solid #fcd9c4"}}>₹{doc.fees}</span>}
                </div>
               
               
                <div className="ad-doc-actions">
                  <button className="ad-btn-schedule">View Schedule</button>
                  <button className="ad-btn-edit" onClick={()=>this.openEdit(doc)}><Ico name="edit" size={14} color="var(--ad-brand)" /> Edit</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   PATIENTS PAGE  — GET /api/patients/getpatientlist
   API shape: PersonID, FirstName, MiddleName, LastName,
              Gender, DOB, BloodGroup, City, State,
              Mobile, Email, Status
════════════════════════════════════════════════════════════ */
const PATIENTS_FALLBACK = [
  { id:"P001", initials:"RS", name:"Raj Sharma",   age:35, gender:"Male",   blood:"O+",  city:"Delhi",   phone:"9876543210", email:"raj@email.com",   status:"Active"   },
  { id:"P002", initials:"PV", name:"Priya Verma",  age:28, gender:"Female", blood:"B+",  city:"Mumbai",  phone:"9876543211", email:"priya@email.com",  status:"Active"   },
  { id:"P003", initials:"AK", name:"Anil Kumar",   age:52, gender:"Male",   blood:"A+",  city:"Jaipur",  phone:"9876543212", email:"anil@email.com",   status:"Active"   },
  { id:"P004", initials:"SR", name:"Sunita Rao",   age:44, gender:"Female", blood:"AB+", city:"Pune",    phone:"9876543213", email:"sunita@email.com", status:"Active"   },
  { id:"P005", initials:"VJ", name:"Vikram Joshi", age:39, gender:"Male",   blood:"O-",  city:"Lucknow", phone:"9876543214", email:"vikram@email.com", status:"Inactive" },
];

function calcAge(dob) {
  if (!dob) return "—";
  return Math.floor((Date.now() - new Date(dob).getTime()) / (1000*60*60*24*365.25));
}

function mapPatient(raw, idx) {
  // ── Real API fields ──────────────────────────────────────
  // patfname, patlname, patDob, patBG, patgender,
  // DocFname, DocLname, DepartmentName, QR_Type,
  // SelfRelative, AppointmentTime, AppointmentDate

  const firstName = raw.patfname   || raw.FirstName  || "";
  const lastName  = raw.patlname   || raw.LastName   || "";
  const fullName  = [firstName, lastName].filter(Boolean).join(" ") || `Patient ${idx+1}`;
  const initials  = [firstName, lastName].filter(Boolean).map(w=>w[0].toUpperCase()).join("");

  // Doctor full name from DocFname + DocLname
  const doctorName = [raw.DocFname, raw.DocLname].filter(Boolean).join(" ");

  // Format appointment date "2026-04-01T00:26:53.000Z" → "01 Apr 2026"
  let apptDate = "—";
  if (raw.AppointmentDate) {
    apptDate = new Date(raw.AppointmentDate).toLocaleDateString("en-IN", {
      day:"2-digit", month:"short", year:"numeric"
    });
  }

  return {
    id:          String(raw.PersonID || raw.PatientID || raw.AppointmentID || idx),
    initials,
    name:        fullName,
    age:         calcAge(raw.patDob  || raw.DOB),
    gender:      raw.patgender       || raw.Gender    || "—",
    blood:       raw.patBG           || raw.BloodGroup || "—",
    city:        raw.City            || "—",
    phone:       raw.Mobile          || raw.Phone     || "—",
    email:       raw.Email           || "—",
    status:      raw.Status          || "Active",
    // appointment-specific fields
    doctor:      doctorName          || "—",
    department:  raw.DepartmentName  || "—",
    apptTime:    raw.AppointmentTime || "—",
    apptDate,
    qrType:      raw.QR_Type         || "—",
    relation:    raw.SelfRelative    || "—",
  };
}

const BLOOD_COLORS = {
  "O+":"#EF4444","O-":"#DC2626","A+":"#3B82F6","A-":"#2563EB",
  "B+":"#8B5CF6","B-":"#7C3AED","AB+":"#059669","AB-":"#047857",
};

class PatientsPage extends Component {
  constructor(props) {
    super(props);
    this.state = { patients:[], loading:true, error:null, search:"", filter:"All" };
  }
  componentDidMount() { this.fetchPatients(); }

  async fetchPatients() {
    this.setState({ loading:true, error:null });
    try {
      const res  = await getRequest(API_ENDPOINTS.PATIENTS);
      const data = await res.json();

      // Handle all likely response shapes
      let rows = [];
      if      (Array.isArray(data))                    rows = data;
      else if (Array.isArray(data.data))               rows = data.data;
      else if (Array.isArray(data.data?.Patient))      rows = data.data.Patient;
      else if (Array.isArray(data.data?.Patients))     rows = data.data.Patients;
      else if (Array.isArray(data.patients))           rows = data.patients;

      this.setState(
        { patients: rows.length>0 ? rows.map(mapPatient) : PATIENTS_FALLBACK, loading:false },
        () => { console.log("setState patients =", this.state.patients); }
      );
    } catch(err) {
      console.error("Patients API error:", err);
      this.setState({ patients:PATIENTS_FALLBACK, loading:false, error:err.message });
    }
  }

  render() {
    const { patients, loading, error, search, filter } = this.state;

    // Client-side search + filter
    const filtered = patients.filter(p => {
      const q = search.toLowerCase();
      const matchSearch = q===""
        || p.name.toLowerCase().includes(q)
        || p.id.toLowerCase().includes(q)
        || p.city.toLowerCase().includes(q)
        || p.phone.includes(q);
      const matchFilter = filter==="All" || p.gender===filter || p.status===filter;
      return matchSearch && matchFilter;
    });

    return (
      <div>
        {/* Page header */}
        <div className="ad-doctors-header ad-fade-up">
          <div>
            <h1 className="ad-page-title">Patients</h1>
            <p className="ad-page-sub">
              {loading ? "Loading…" : `${patients.length} registered patients`}
            </p>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            {error && !loading && (
              <button onClick={()=>this.fetchPatients()} style={{padding:"9px 16px",border:"1.5px solid var(--ad-border)",borderRadius:10,background:"transparent",cursor:"pointer",fontSize:13,fontWeight:600,color:"var(--ad-text-2)",fontFamily:"var(--ad-font-body)"}}>↺ Retry</button>
            )}
            <button className="ad-btn-add-doc">
              <Ico name="plus" size={16} color="#fff" /> Add Patient
            </button>
          </div>
        </div>

        {/* Search + Filter toolbar */}
        <div className="ad-pt-toolbar ad-fade-up-1">
          <div className="ad-pt-search-wrap">
            <Ico name="search" size={15} color="var(--ad-text-3)" />
            <input
              className="ad-pt-search"
              placeholder="Search by name, ID, city or phone…"
              value={search}
              onChange={e=>this.setState({search:e.target.value})}
            />
          </div>
          <div className="ad-pt-filters">
            {["All","Male","Female","Active","Inactive"].map(f=>(
              <button key={f}
                className={`ad-pt-filter-btn${filter===f?" active":""}`}
                onClick={()=>this.setState({filter:f})}>
                {f}
              </button>
            ))}
          </div>
        </div>

        {/* Loading skeleton */}
        {loading && (
          <div className="ad-card ad-fade-up-1">
            {[1,2,3,4,5].map(n=>(
              <div key={n} style={{display:"flex",alignItems:"center",gap:14,padding:"16px 20px",borderBottom:"1px solid var(--ad-border)"}}>
                <div style={{width:40,height:40,borderRadius:10,background:"var(--ad-border)",flexShrink:0}} />
                <div style={{flex:1}}>
                  <div style={{height:13,background:"var(--ad-border)",borderRadius:6,marginBottom:6,width:"35%"}} />
                  <div style={{height:11,background:"var(--ad-border)",borderRadius:6,width:"55%"}} />
                </div>
                <div style={{width:70,height:24,background:"var(--ad-border)",borderRadius:20}} />
                <div style={{width:90,height:24,background:"var(--ad-border)",borderRadius:20}} />
              </div>
            ))}
          </div>
        )}

        {/* Patient table */}
        {!loading && (
          <div className="ad-card ad-fade-up-2">
            {filtered.length === 0 ? (
              <div className="ad-coming-soon" style={{minHeight:220}}>
                <Ico name="user" size={36} color="var(--ad-text-3)" />
                <p style={{color:"var(--ad-text-3)"}}>No patients match your search.</p>
              </div>
            ) : (
              <div style={{overflowX:"auto"}}>
                <table className="ad-table">
                  <thead>
                    <tr>
                      <th>Patient</th>
                      <th>Age / Gender</th>
                      <th>Blood</th>
                      <th>Doctor / Dept</th>
                      <th>Appointment</th>
                      <th>QR Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.map((p,i)=>(
                      <tr key={p.id}>
                        {/* Avatar + Name + ID */}
                        <td>
                          <div style={{display:"flex",alignItems:"center",gap:10}}>
                            <div style={{width:36,height:36,borderRadius:9,flexShrink:0,background:"var(--ad-brand-light)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,color:"var(--ad-brand)"}}>
                              {p.initials}
                            </div>
                            <div>
                              <div style={{fontWeight:600,fontSize:13}}>{p.name}</div>
                              <div style={{fontSize:11,color:"var(--ad-text-3)"}}>{p.gender} · {p.relation}</div>
                            </div>
                          </div>
                        </td>
                        {/* Age / Blood */}
                        <td>
                          <div style={{fontWeight:500}}>{p.age} yrs</div>
                          <span style={{display:"inline-flex",alignItems:"center",gap:3,fontSize:11,fontWeight:700,padding:"2px 7px",borderRadius:20,color:"#fff",background:BLOOD_COLORS[p.blood]||"var(--ad-text-3)"}}>
                            <Ico name="drop" size={9} color="#fff" /> {p.blood}
                          </span>
                        </td>
                        {/* Blood group — Gender */}
                        <td style={{color:"var(--ad-text-2)",fontSize:12}}>{p.gender}</td>
                        {/* Doctor + Department */}
                        <td>
                          <div style={{fontWeight:600,fontSize:13}}>Dr. {p.doctor}</div>
                          <div style={{fontSize:11,color:"var(--ad-text-3)"}}>{p.department}</div>
                        </td>
                        {/* Appointment date + time */}
                        <td>
                          <div style={{fontWeight:500,fontSize:13}}>{p.apptDate}</div>
                          <div style={{fontSize:11,color:"var(--ad-text-3)"}}>{p.apptTime}</div>
                        </td>
                        {/* QR Type */}
                        <td>
                          <span style={{
                            fontSize:11,fontWeight:700,padding:"3px 9px",borderRadius:20,whiteSpace:"nowrap",
                            background: p.qrType==="Temprory QR" ? "var(--ad-warn-light)"  : "var(--ad-brand-light)",
                            color:      p.qrType==="Temprory QR" ? "var(--ad-warn)"         : "var(--ad-brand)",
                          }}>{p.qrType}</span>
                        </td>
                        {/* Action */}
                        <td>
                          <button className="ad-btn-edit" style={{padding:"6px 10px"}}>
                            <Ico name="eye" size={13} color="var(--ad-brand)" /> View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   ADMIN APPOINTMENTS PAGE
════════════════════════════════════════════════════════════ */
class AdminAppointmentsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appointments: [],
      loading:      true,
      error:        null,
      search:       '',
      filter:       'all',
      actionLoading: null,
      lastUpdated:  null,
      countdown:    60,
    };
  }

  componentDidMount() {
    this.fetchAppointments();
    this._timer     = setInterval(() => this.fetchAppointments(true), 60000);
    this._countdown = setInterval(() => {
      this.setState(s => ({ countdown: s.countdown > 0 ? s.countdown - 1 : 60 }));
    }, 1000);
  }

  componentWillUnmount() {
    if (this._timer)     clearInterval(this._timer);
    if (this._countdown) clearInterval(this._countdown);
  }

  async fetchAppointments(silent = false) {
    this.setState({ loading: true, error: null });
    try {
      const res  = await getRequest(API_ENDPOINTS.ALL_APPOINTMENTS);
      const data = await res.json();
      console.log('Admin appointments:', data);
      let rows = [];
      if (data.status && Array.isArray(data.data) && Array.isArray(data.data[0])) rows = data.data[0];
      else if (Array.isArray(data.data)) rows = data.data;
      else if (Array.isArray(data))      rows = data;
      this.setState({ appointments: rows, loading: false, lastUpdated: new Date(), countdown: 60 });
    } catch (err) {
      this.setState({ loading: false, error: err.message });
    }
  }

  async markPaid(apptId) {
    this.setState({ actionLoading: apptId });
    try {
      const res  = await postRequest(API_ENDPOINTS.UPDATE_PAYMENT, {
        AppointmentID: String(apptId),
        PaymentStatus: 'Paid',
      });
      const data = await res.json();
      console.log('Update payment response:', data);
      // Update local state
      this.setState(s => ({
        appointments: s.appointments.map(a =>
          (a.AppointmentID || a.id) == apptId
            ? { ...a, PaymentStatus: 'Paid' }
            : a
        ),
        actionLoading: null,
      }));
    } catch (err) {
      console.error('Update payment error:', err);
      this.setState({ actionLoading: null });
    }
  }

  mapRow(a, i) {
    const date     = a.Appointmentdate || a.AppointmentDate || '';
    const fmtDate  = date ? new Date(date).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'}) : '—';
    const dob      = a.PatientDOB || '';
    const age      = dob ? Math.floor((Date.now() - new Date(dob).getTime()) / (1000*60*60*24*365.25)) : '—';
    const rawStatus = (a.PaymentStatus || 'pending').toLowerCase();
    const status   = (rawStatus === 'completed' || rawStatus === 'paid') ? 'paid' : 'pending';
    return {
      id:       a.AppointmentID || i+1,
      patient:  `${a.PatientFirstName||''} ${a.PatientLastName||''}`.trim() || '—',
      gender:   a.PatientGender || '—',
      blood:    a.PatientBloodGroup || '—',
      age,
      doctor:   `Dr. ${a.DoctorFirstName||''} ${a.DoctorLastName||''}`.trim(),
      dept:     a.DepartmentName || '—',
      spec:     a.Specilization  || '—',
      selfRel:  a.SelfRelative   || '—',
      date:     fmtDate,
      time:     a.Time           || '—',
      payment:  a.Payment != null ? `₹${a.Payment}` : '—',
      rawStatus:a.PaymentStatus  || '—',
      status,
      reason:   a.Reason         || '—',
      qrType:   a.QR_Type        || '—',
    };
  }

  render() {
    const { appointments, loading, error, search, filter, actionLoading } = this.state;

    const allRows = appointments.map((a,i) => ({ ...this.mapRow(a,i), _raw: a }));
    const rows = allRows.filter(r => {
      const q = search.toLowerCase();
      const matchSearch = !q || r.patient.toLowerCase().includes(q) || r.doctor.toLowerCase().includes(q) || String(r.id).includes(q) || r.dept.toLowerCase().includes(q);
      const matchFilter = filter === 'all' || r.status === filter;
      return matchSearch && matchFilter;
    });

    const totalPaid    = allRows.filter(r => r.status === 'paid').length;
    const totalPending = allRows.filter(r => r.status === 'pending').length;

    const FILTERS = [
      { k:'all',     label:`All (${allRows.length})`       },
      { k:'paid',    label:`Paid (${totalPaid})`           },
      { k:'pending', label:`Pending (${totalPending})`     },
    ];

    return (
      <div>
        <div className="ad-page-header ad-fade-up" style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <div>
            <h1 className="ad-page-title">Appointments</h1>
            <p className="ad-page-sub">
              {loading ? 'Loading…' : `${allRows.length} total · ${totalPaid} paid · ${totalPending} pending`}
            </p>
          </div>
          <button onClick={() => this.fetchAppointments()}
            style={{border:'1.5px solid var(--ad-border)',background:'transparent',borderRadius:10,padding:'7px 14px',fontSize:12,fontWeight:600,cursor:'pointer',color:'var(--ad-text-2)',fontFamily:'inherit'}}>
            ↺ Refresh
          </button>
        </div>

        {/* Error */}
        {error && (
          <div style={{background:'#FFF0EB',border:'1px solid #fcd9c4',borderRadius:10,padding:'10px 14px',marginBottom:14,fontSize:13,color:'#FF6B35',display:'flex',gap:8,alignItems:'center'}}>
            <Ico name="alert" size={14} color="#FF6B35" /> Could not load appointments — {error}
          </div>
        )}

        {/* Search + filter */}
        <div className="ad-card ad-fade-up" style={{marginBottom:16,padding:14}}>
          <div style={{display:'flex',gap:12,alignItems:'center',flexWrap:'wrap'}}>
            <div style={{flex:1,minWidth:200,position:'relative',display:'flex',alignItems:'center'}}>
              <Ico name="search" size={15} color="var(--ad-text-3)" style={{position:'absolute',left:12}} />
              <input value={search} onChange={e=>this.setState({search:e.target.value})}
                placeholder="Search patient, doctor, ID…"
                style={{width:'100%',height:42,paddingLeft:38,paddingRight:14,border:'1.5px solid var(--ad-border)',borderRadius:10,fontSize:13,fontFamily:'inherit',outline:'none',boxSizing:'border-box'}}
                onFocus={e=>e.target.style.borderColor='var(--ad-brand)'} onBlur={e=>e.target.style.borderColor='var(--ad-border)'} />
            </div>
            <div style={{display:'flex',gap:6}}>
              {FILTERS.map(f => (
                <button key={f.k} onClick={() => this.setState({filter:f.k})}
                  style={{padding:'8px 14px',borderRadius:8,border:'1.5px solid',borderColor:filter===f.k?'var(--ad-brand)':'var(--ad-border)',background:filter===f.k?'var(--ad-brand-light,#E8F1FF)':'transparent',color:filter===f.k?'var(--ad-brand)':'var(--ad-text-2)',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:'inherit'}}>
                  {f.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="ad-card ad-fade-up-1">

          {/* Loading skeleton */}
          {loading && (
            <div>
              {[1,2,3,4,5].map(n=>(
                <div key={n} style={{display:'flex',gap:14,padding:'14px 16px',borderBottom:'1px solid var(--ad-border)',alignItems:'center',opacity:.5}}>
                  <div style={{width:60,height:11,background:'var(--ad-border)',borderRadius:6}} />
                  <div style={{flex:1}}><div style={{height:12,background:'var(--ad-border)',borderRadius:6,width:'40%',marginBottom:5}} /><div style={{height:10,background:'var(--ad-border)',borderRadius:6,width:'25%'}} /></div>
                  <div style={{width:90,height:11,background:'var(--ad-border)',borderRadius:6}} />
                  <div style={{width:70,height:11,background:'var(--ad-border)',borderRadius:6}} />
                  <div style={{width:60,height:24,background:'var(--ad-border)',borderRadius:20}} />
                  <div style={{width:80,height:30,background:'var(--ad-border)',borderRadius:8}} />
                </div>
              ))}
            </div>
          )}

          {/* Empty */}
          {!loading && rows.length === 0 && (
            <div style={{textAlign:'center',padding:'44px 20px',color:'var(--ad-text-3)'}}>
              <Ico name="calendar" size={36} color="var(--ad-border)" />
              <div style={{marginTop:10,fontSize:13}}>{search||filter!=='all'?'No appointments match your filter.':'No appointments found.'}</div>
            </div>
          )}

          {/* Table */}
          {!loading && rows.length > 0 && (
            <div style={{overflowX:'auto'}}>
              <table className="ad-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Patient</th>
                    <th>Doctor</th>
                    <th>Department</th>
                    <th>Date · Time</th>
                    <th>Reason</th>
                    <th>Fees</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, i) => {
                    const isPending = row.status === 'pending';
                    const isUpdating = actionLoading == row.id;
                    return (
                      <tr key={i} style={{background: isPending ? '#FFFAF7' : 'transparent'}}>
                        <td><span style={{fontFamily:'monospace',fontWeight:700,color:'var(--ad-brand)',fontSize:13}}>#{row.id}</span></td>
                        <td>
                          <div style={{fontWeight:600,fontSize:13}}>{row.patient}</div>
                          <div style={{fontSize:11,color:'var(--ad-text-3)'}}>{row.age} yrs · {row.gender} · {row.blood}</div>
                          <div style={{fontSize:11,color:'var(--ad-text-3)',textTransform:'capitalize'}}>{row.selfRel}</div>
                        </td>
                        <td>
                          <div style={{fontWeight:600,fontSize:13}}>{row.doctor}</div>
                          <div style={{fontSize:11,color:'var(--ad-text-3)'}}>{row.spec}</div>
                        </td>
                        <td style={{fontSize:12,color:'var(--ad-text-2)'}}>{row.dept}</td>
                        <td style={{fontSize:12,color:'var(--ad-text-2)'}}>{row.date}<br/><span style={{color:'var(--ad-text-3)'}}>{row.time}</span></td>
                        <td style={{fontSize:12,color:'var(--ad-text-2)',maxWidth:120,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{row.reason}</td>
                        <td style={{fontWeight:700,fontSize:13}}>{row.payment}</td>
                        <td>
                          <span style={{fontSize:11,fontWeight:700,padding:'4px 10px',borderRadius:20,
                            background: isPending?'#FFF0EB':'#E6FAF5',
                            color:      isPending?'#FF6B35':'#059669'}}>
                            {row.rawStatus}
                          </span>
                        </td>
                        <td>
                          {isPending ? (
                            <button
                              onClick={() => this.markPaid(row.id)}
                              disabled={isUpdating}
                              style={{padding:'7px 14px',borderRadius:8,border:'none',background:'var(--ad-brand)',color:'#fff',fontSize:12,fontWeight:700,cursor:isUpdating?'not-allowed':'pointer',opacity:isUpdating?.6:1,fontFamily:'inherit',whiteSpace:'nowrap'}}>
                              {isUpdating ? 'Updating…' : '✓ Mark Paid'}
                            </button>
                          ) : (
                            <span style={{fontSize:12,color:'var(--ad-text-3)'}}>—</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   OTHER PAGES — stub
════════════════════════════════════════════════════════════ */

/* ═══════════════════════════════════════════════════════════════
   WALK-IN PATIENT REGISTRATION
   Same flow as guest booking — 2 steps: Patient Info + Payment
═══════════════════════════════════════════════════════════════ */
function mapWalkInDoctor(raw, i) {
  const name  = [raw.FirstName, raw.MiddleName, raw.LastName].filter(Boolean).join(' ');
  const slots = [];
  if (raw.OPD_Time) {
    const [s, e] = raw.OPD_Time.split('-');
    if (s && e) {
      const toM = t => { const [h,m]=t.trim().split(':').map(Number); return h*60+(m||0); };
      const fmt  = m => { const h=Math.floor(m/60),mn=m%60,ap=h>=12?'PM':'AM',h12=h>12?h-12:h===0?12:h; return `${h12}:${String(mn).padStart(2,'0')} ${ap}`; };
      let c=toM(s); const en=toM(e);
      while(c<en){ slots.push(fmt(c)); c+=30; }
    }
  }
  return { id:String(raw.DoctorID||i), name:`Dr. ${name}`, dept:raw.DepartmentName||'', qual:raw.Specilization||'', fees:raw.OPD_Fees||'500', slots };
}

/* ── WalkIn QR — generates QR and saves to DB ─────────────── */
function loadQRLibAdmin() {
  return new Promise(resolve => {
    if (window.QRCode) { resolve(); return; }
    const s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';
    s.onload = resolve; s.onerror = resolve;
    document.head.appendChild(s);
  });
}

class WalkInQR extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = { dataUrl: null, saved: false };
  }

  componentDidMount()  { this.generate(); }
  componentDidUpdate(p){ if (p.apptId !== this.props.apptId) this.generate(); }

  async generate() {
    const { apptId, isPaid } = this.props;
    if (!apptId) return;
    await loadQRLibAdmin();
    if (!this.ref.current || !window.QRCode) return;

    this.ref.current.innerHTML = '';
    const scanUrl = window.location.origin + '/scan?id=' + apptId;

    new window.QRCode(this.ref.current, {
      text: scanUrl, width: 200, height: 200,
      colorDark: '#0D1117', colorLight: '#FFFFFF',
      correctLevel: window.QRCode.CorrectLevel.L,
    });

    // Extract base64 after render and save to DB
    setTimeout(() => {
      if (!this.ref.current) return;
      const canvas = this.ref.current.querySelector('canvas');
      if (!canvas) return;
      const base64 = canvas.toDataURL('image/png');
      this.setState({ dataUrl: base64 });
      this.saveToDatabase(apptId, scanUrl, base64, isPaid);
    }, 600);
  }

  async saveToDatabase(apptId, scanUrl, base64, isPaid) {
    if (this.state.saved) return;
    try {
      const payload = {
        AppointmentID: String(apptId),
        QR_Data:       scanUrl,
        QR_Image:      base64,
        QRType:        isPaid ? 'Official QR' : 'Temporary QR',
        Status:        isPaid ? 'Paid' : 'Pending',
      };
      console.log('Saving walk-in QR to DB for Appt #', apptId);
      const res  = await postRequest(API_ENDPOINTS.QR_GENERATE, payload);
      const data = await res.json();
      console.log('Walk-in QR saved ✅', data);
      this.setState({ saved: true });
    } catch (err) {
      console.warn('Walk-in QR save failed (non-critical):', err.message);
    }
  }

  render() {
    const { isPaid } = this.props;
    const { dataUrl } = this.state;
    const accent = isPaid ? '#059669' : '#D97706';
    const border = isPaid ? '#a7f3d0' : '#fcd9c4';
    const bg     = isPaid ? '#F0FDF4' : '#FFFBEB';

    return (
      <div style={{textAlign:'center'}}>
        <div style={{
          display:'inline-flex', alignItems:'center', justifyContent:'center',
          padding:14, borderRadius:16, background:'#fff',
          boxShadow:'0 4px 20px rgba(0,0,0,.12)',
          border:`2.5px solid ${border}`,
          minWidth:228, minHeight:228, position:'relative', marginBottom:12,
        }}>
          {/* qrcodejs renders here */}
          <div ref={this.ref} style={{position: dataUrl?'absolute':'relative', opacity: dataUrl?0:1, pointerEvents:'none'}} />

          {/* Show extracted PNG once ready */}
          {dataUrl && (
            <img src={dataUrl} alt="QR Code" style={{width:200,height:200,display:'block'}} />
          )}

          {/* Spinner while generating */}
          {!dataUrl && (
            <div style={{position:'absolute',inset:0,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:8,color:'#94A3B8',fontSize:12}}>
              <div style={{width:32,height:32,border:'3px solid #E2E8F0',borderTop:`3px solid #0A6EFF`,borderRadius:'50%',animation:'wiSpin 1s linear infinite'}} />
              Generating QR…
            </div>
          )}
        </div>

        <div style={{fontSize:11,fontWeight:800,letterSpacing:1.2,color:accent,textTransform:'uppercase',marginBottom:8}}>
          {isPaid ? '✓ Official QR Code' : '⏳ Temporary QR Code'}
        </div>

        {/* Download button */}
        {dataUrl && (
          <button onClick={() => {
            const a = document.createElement('a');
            a.href = dataUrl;
            a.download = 'QR-Appt-' + this.props.apptId + '.png';
            a.click();
          }} style={{
            padding:'7px 18px', borderRadius:20, border:'1.5px solid #E2E8F0',
            background:'#fff', fontSize:12, fontWeight:600, cursor:'pointer',
            fontFamily:'inherit', color:'#2d3452', display:'inline-flex', alignItems:'center', gap:6,
          }}>
            ⬇ Download QR
          </button>
        )}
      </div>
    );
  }
}

/* ── WalkIn form helpers — defined at module level so they never recreate on render ── */
function WI_F({ label, req, err, children }) {
  return (
    <div style={{marginBottom:14}}>
      {label && <label style={{fontSize:12,fontWeight:600,color:'var(--ad-text-2)',display:'block',marginBottom:5}}>{label}{req&&<span style={{color:'#ef4444',marginLeft:2}}>*</span>}</label>}
      {children}
      {err && <div style={{fontSize:11,color:'#ef4444',marginTop:3}}>{err}</div>}
    </div>
  );
}
function WI_inp(hasErr) {
  return {
    width:'100%', height:42, borderRadius:10,
    border:`1.5px solid ${hasErr?'#ef4444':'var(--ad-border)'}`,
    padding:'0 12px', fontSize:14, fontFamily:'inherit',
    outline:'none', boxSizing:'border-box',
  };
}
function WI_sel(hasErr) {
  return {
    width:'100%', height:42, borderRadius:10,
    border:`1.5px solid ${hasErr?'#ef4444':'var(--ad-border)'}`,
    padding:'0 12px', fontSize:14, fontFamily:'inherit',
    outline:'none', boxSizing:'border-box', background:'#fff',
  };
}

class WalkInPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      form: {
        firstName:'', lastName:'', dob:'', gender:'', bloodGroup:'',
        mobile:'', email:'', reason:'',
        doctor:null, date:'', time:'',
      },
      errors: {},
      doctors: [], doctorsLoading: true,
      apiSlots: [], slotsLoading: false,
      payMethod: '',
      bookingLoading: false, bookingError: null,
      bookingApptId: null, payLater: false,
    };
  }

  componentDidMount() { this.fetchDoctors(); this.fetchDepartments(); }

  async fetchTimeSlotsForDoctor(doctorId, date) {
    if (!doctorId) return;
    this.setState({ slotsLoading: true, apiSlots: [] });
    try {
      const payload = { DoctorID: doctorId };
      if (date) payload.AppointmentDate = date;
      const res  = await postRequest(API_ENDPOINTS.TIME_SLOT_LIST_ForPatient, payload);
      const data = await res.json();
      console.log('Time slots for doctor', doctorId, ':', data);
      let rows = [];
      if (data.status && Array.isArray(data.data?.Doctor)) rows = data.data.Doctor;
      else if (data.status && Array.isArray(data.data))    rows = data.data;
      else if (Array.isArray(data))                        rows = data;
      this.setState({ slotsLoading: false, apiSlots: rows });
    } catch(err) {
      console.warn('fetchTimeSlotsForDoctor error:', err.message);
      this.setState({ slotsLoading: false });
    }
  }


  async fetchDepartments() {
    try {
      const res  = await getRequest(API_ENDPOINTS.DEPARTMENT_LIST);
      const data = await res.json();
      let rows = [];
      if (data.status && Array.isArray(data.data?.[0])) rows = data.data[0];
      else if (Array.isArray(data.data?.Department))    rows = data.data.Department;
      else if (Array.isArray(data.data))                rows = data.data;
      else if (Array.isArray(data))                     rows = data;
      console.log('Departments:', rows);
      this.setState({ departments: rows });
    } catch(err) {
      console.warn('Department fetch failed:', err.message);
    }
  }

  async fetchDoctors() {
    try {
      const res  = await getRequest(API_ENDPOINTS.DOCTOR_LIST);
      const data = await res.json();
      console.log('WalkIn doctors raw:', data);
      let rows = [];
      if (data.status && Array.isArray(data.data?.[0]))       rows = data.data[0];        // SP double-array
      else if (Array.isArray(data.data?.Doctor))               rows = data.data.Doctor;    // { Doctor: [...] }
      else if (Array.isArray(data.data))                       rows = data.data;
      else if (Array.isArray(data?.Doctor))                    rows = data.Doctor;
      else if (Array.isArray(data))                            rows = data;
      console.log('WalkIn doctors rows:', rows.length);
      this.setState({ doctors: rows.map(mapWalkInDoctor), doctorsLoading: false });
    } catch(err) {
      console.error('WalkIn fetchDoctors error:', err);
      this.setState({ doctorsLoading: false });
    }
  }

  setForm(k, v) { this.setState(s => ({ form:{...s.form,[k]:v}, errors:{...s.errors,[k]:''} })); }

  calcAge(dob) {
    if (!dob) return '';
    return Math.floor((Date.now() - new Date(dob).getTime()) / (1000*60*60*24*365.25));
  }

  validate() {
    const { form } = this.state;
    const e = {};
    if (!form.firstName.trim()) e.firstName = 'Required';
    if (!form.lastName.trim())  e.lastName  = 'Required';
    if (!form.dob)              e.dob       = 'Required';
    if (!form.gender)           e.gender    = 'Required';
    if (!form.mobile.trim() || !/^\d{10}$/.test(form.mobile)) e.mobile = 'Valid 10-digit number required';
    if (!form.reason.trim())    e.reason    = 'Required';
    if (!form.doctor)           e.doctor    = 'Select a doctor';
    if (!form.date)             e.date      = 'Select a date';
    if (!form.time)             e.time      = 'Select a time slot';
    return e;
  }

  async book(payLater) {
    const errs = this.validate();
    if (Object.keys(errs).length > 0) { this.setState({ errors: errs }); return; }
    const { form } = this.state;
    this.setState({ bookingLoading: true, bookingError: null, payLater });

    // Get logged-in admin PersonID
    const raw  = localStorage.getItem('dg_user');
    const admin = raw ? JSON.parse(raw) : null;

    const payload = {
      PersonID:        null,                           // guest walk-in
      DoctorID:        String(form.doctor?.id || ''),
      AppointmentDate: form.date,
      AppointmentTime: form.time,
      ReasonForVisit:  form.reason,
      SelfRelative:    'self',
      QR_Type:         payLater ? 'Temprory QR' : 'Official QR',
      OPD_Fees:        String(form.doctor?.fees || '500'),
      PaymentStatus:   payLater ? 'Pending' : 'Paid',
      FirstName:       form.firstName,
      Lastname:        form.lastName,
      DOB:             form.dob,
      BloodGroup:      form.bloodGroup,
      Gender:          form.gender,
      Mobile:          form.mobile,
      email:           form.email,
      Channel:         "Walkin",
      DepartmentName:  form.doctor?.dept || '',
      RegisteredBy:    admin?.personId || '',    // admin who registered
    };

    try {
      const res  = await postRequest(API_ENDPOINTS.BOOK_APPOINTMENT, payload);
      const data = await res.json();
      console.log('WalkIn booking response:', data);
      // Handle all known response shapes — same as patient booking
      const apptId =
            // SP double-array shape
     data.data?.data?.appointmentId
       
        || null;
      console.log('WalkIn resolved apptId:', apptId);
      if (!apptId) {
        // API succeeded but no ID returned — show error with raw response
        this.setState({ bookingLoading: false, bookingError: 'Booking succeeded but no Appointment ID returned. Check console.', step: 2, bookingApptId: null });
        return;
      }
      this.setState({ bookingLoading: false, bookingApptId: String(apptId), step: 2 });
    } catch (err) {
      this.setState({ bookingLoading: false, bookingError: err.message, step: 2, bookingApptId: 'WALK-' + Date.now() });
    }
  }

  reset() {
    this.setState({
      step:1, form:{firstName:'',lastName:'',dob:'',gender:'',bloodGroup:'',mobile:'',email:'',reason:'',doctor:null,date:'',time:''},
      errors:{}, payMethod:'', bookingLoading:false, bookingError:null, bookingApptId:null, payLater:false,
    });
  }

  render() {
    const { step, form, errors, doctors, doctorsLoading, payMethod, bookingLoading, bookingError, bookingApptId, payLater, slotsLoading } = this.state;
    const BG  = ['A+','A-','B+','B-','AB+','AB-','O+','O-'];
    const todayStr = new Date().toISOString().split('T')[0];
    const isToday  = form.date === todayStr;
    const now = new Date();
    const parseSlot = s => {
      const m = s.match(/^(\d+):(\d+)\s*(AM|PM)$/i);
      if (!m) return null;
      let h = parseInt(m[1]), mn = parseInt(m[2]);
      if (m[3].toUpperCase()==='PM' && h!==12) h+=12;
      if (m[3].toUpperCase()==='AM' && h===12) h=0;
      const t=new Date(); t.setHours(h,mn,0,0); return t;
    };
    // Parse slot start time for "passed" check
    const slotPassed = slotStr => {
      // Only hide passed slots when today is selected AND a date is chosen
      if (!form.date || !isToday || !slotStr) return false;
      // Use END time — slot "10:00 AM-01:00 PM" is visible until 12:59 PM
      const parts = slotStr.split(/\s*-\s*/);
      const endPart = parts[parts.length - 1].trim();
      const m = endPart.match(/^(\d+):(\d+)\s*(AM|PM)$/i);
      if (!m) return false;
      let h = parseInt(m[1]), min = parseInt(m[2]);
      const p = m[3].toUpperCase();
      if (p === 'PM' && h !== 12) h += 12;
      if (p === 'AM' && h === 12) h = 0;
      // Subtract 1 minute — slot visible until end time - 1 min
      const endTime = new Date();
      endTime.setHours(h, min - 1, 59, 0);
      return now > endTime;
    };

    // Use API slots if available
    const { apiSlots } = this.state;
    const slots = apiSlots.length > 0
      ? apiSlots
          .filter(s => (s.Status||'Active').toLowerCase()==='active')
          .filter(s => (s.booked_count||0) < (s.No_of_Patient||1))
          .map(s => (s.TimeSlot||'').trim())
          .filter(Boolean)
          .filter(s => !slotPassed(s))
      :apiSlots

    // F, inpStyle, selStyle are defined at module level (below)

    if (step === 2) {
      // Confirmation screen
      const isPaid = !payLater;
      const scanUrl = `${window.location.origin}/scan?id=${bookingApptId}`;
      return (
        <div style={{maxWidth:520,margin:'0 auto'}}>
          <div className="ad-page-header">
            <h1 className="ad-page-title">Walk-in Registration</h1>
          </div>
          <div className="ad-card" style={{textAlign:'center',padding:32}}>
            <style>{'@keyframes wiSpin{to{transform:rotate(360deg)}}'}</style>

            {/* Status icon */}
            <div style={{width:64,height:64,borderRadius:20,background:isPaid?'#D1FAE5':'#FEF3C7',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 16px'}}>
              <svg width={28} height={28} viewBox="0 0 24 24" fill="none" stroke={isPaid?'#059669':'#D97706'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d={isPaid?'M20 6L9 17l-5-5':'M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0'} />
              </svg>
            </div>
            <div style={{fontWeight:800,fontSize:20,marginBottom:8}}>{isPaid?'Patient Registered!':'Registration Received!'}</div>
            <div style={{color:'var(--ad-text-2)',fontSize:13,marginBottom:24}}>
              {isPaid ? 'Payment confirmed. Official QR issued.' : 'Temporary QR issued. Patient to pay at counter.'}
            </div>

            {/* QR Code */}
            {bookingApptId && (
              <div style={{marginBottom:24}}>
                <WalkInQR apptId={bookingApptId} isPaid={isPaid} />
              </div>
            )}

            {bookingError && (
              <div style={{background:'#FFF0EB',border:'1px solid #fcd9c4',borderRadius:10,padding:'10px 14px',marginBottom:16,fontSize:13,color:'#ef4444'}}>
                Note: {bookingError}
              </div>
            )}

            {/* Patient summary */}
            <div style={{background:'var(--ad-bg)',borderRadius:12,padding:16,textAlign:'left',marginBottom:20,display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px 20px',fontSize:13}}>
              {[
                {l:'Patient',    v:`${form.firstName} ${form.lastName}`},
                {l:'Appt ID',    v:`#${bookingApptId}`},
                {l:'Doctor',     v:form.doctor?.name||'—'},
                {l:'Department', v:form.doctor?.dept||'—'},
                {l:'Date',       v:form.date},
                {l:'Time',       v:form.time},
                {l:'Mobile',     v:form.mobile},
                {l:'Fees',       v:`₹${form.doctor?.fees||'500'}`},
                {l:'Status',     v:isPaid?'Paid':'Pending'},
              ].map((r,i)=>(
                <div key={i}>
                  <div style={{fontSize:10,color:'var(--ad-text-3)',textTransform:'uppercase',letterSpacing:.5,marginBottom:2,fontWeight:600}}>{r.l}</div>
                  <div style={{fontWeight:600,color:'var(--ad-text-1)'}}>{r.v}</div>
                </div>
              ))}
            </div>

            {/* Credentials */}
            <div style={{background:'#F0FDF4',borderRadius:12,border:'1px solid #a7f3d0',padding:16,textAlign:'left',marginBottom:20}}>
              <div style={{fontWeight:700,fontSize:13,color:'#065f46',marginBottom:10}}>📋 Patient Login Credentials</div>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:6}}>
                <span style={{fontSize:12,color:'#6b7280'}}>Username:</span>
                <span style={{fontSize:13,fontWeight:700,color:'#065f46',fontFamily:'monospace'}}>{form.email||form.mobile}</span>
              </div>
              <div style={{display:'flex',justifyContent:'space-between'}}>
                <span style={{fontSize:12,color:'#6b7280'}}>Password:</span>
                <span style={{fontSize:13,fontWeight:700,color:'#065f46',fontFamily:'monospace'}}>{form.mobile}</span>
              </div>
            </div>

            {/* Scan link */}
            {bookingApptId && (
              <div style={{background:'#EFF6FF',borderRadius:10,border:'1px solid #bfdbfe',padding:'10px 14px',fontSize:12,color:'#1e40af',marginBottom:20,wordBreak:'break-all'}}>
                🔗 QR Scan Link: <a href={scanUrl} target="_blank" rel="noreferrer" style={{color:'#1d4ed8'}}>{scanUrl}</a>
              </div>
            )}

            <div style={{display:'flex',gap:10,justifyContent:'center'}}>
              <button onClick={()=>this.reset()}
                style={{padding:'10px 24px',borderRadius:10,border:'1.5px solid var(--ad-border)',background:'#fff',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:'inherit',color:'var(--ad-text-1)'}}>
                + Register Another
              </button>
              {bookingApptId && (
                <button onClick={()=>window.open(scanUrl,'_blank')}
                  style={{padding:'10px 24px',borderRadius:10,border:'none',background:'var(--ad-brand)',color:'#fff',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:'inherit'}}>
                  View QR
                </button>
              )}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div style={{maxWidth:720,margin:'0 auto'}}>
        <div className="ad-page-header">
          <div>
            <h1 className="ad-page-title">Register Walk-in Patient</h1>
            <p className="ad-page-subtitle">Fill in patient details to book and issue QR</p>
          </div>
        </div>

        <div className="ad-card">
          <div style={{padding:24}}>

            {/* Doctor + Date + Time */}
            <div style={{fontWeight:700,fontSize:13,color:'var(--ad-text-3)',textTransform:'uppercase',letterSpacing:.5,marginBottom:14,paddingBottom:8,borderBottom:'1px solid var(--ad-border)'}}>
              📅 Appointment Details
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14}}>
              <WI_F label="Doctor" req err={errors.doctor}>
                <select style={WI_sel(!!errors.doctor)} value={form.doctor?.id||''} onChange={e=>{
                  const d=doctors.find(x=>x.id===e.target.value)||null;
                  this.setForm('doctor',d); this.setForm('time','');
                  
                }}>
                  <option value="">{doctorsLoading?'Loading…':'— Select Doctor —'}</option>
                  {doctors.map(d=><option key={d.id} value={d.id}>{d.name} · {d.dept} · ₹{d.fees}</option>)
     
                  }
                </select>
              </WI_F>
              <WI_F label="Appointment Date" req err={errors.date}>
                <input type="date" style={WI_inp(!!errors.date)} value={form.date} min={todayStr}
                  onChange={e=>{this.setForm('date',e.target.value);this.setForm('time','');

                    if (form.doctor?.id) this.fetchTimeSlotsForDoctor(form.doctor.id, e.target.value);
                  }} />
              </WI_F>
            </div>
            <WI_F label="Time Slot" req err={errors.time}>
              <select style={WI_sel(!!errors.time)} value={form.time} onChange={e=>this.setForm('time',e.target.value)} disabled={!form.doctor||!form.date||slotsLoading}>
                <option value="">{!form.doctor?'Select doctor first':slotsLoading?'Loading slots…':!form.date?'Select date first':slots.length===0?'No slots available':'Select time slot'}</option>
                {slots.map(t=><option key={t}>{t}</option>)}
              </select>
              {slots.length===0 && !slotsLoading && form.doctor && form.date && <div style={{fontSize:11,color:'#D97706',marginTop:3}}>No slots available — all booked or time passed.</div>}
            </WI_F>

            {/* Reason */}
            <WI_F label="Reason for Visit" req err={errors.reason}>
              <textarea style={{...WI_inp(!!errors.reason),height:72,padding:'10px 12px',resize:'vertical'}} placeholder="Chief complaint / symptoms…"
                value={form.reason} onChange={e=>this.setForm('reason',e.target.value)} />
            </WI_F>

            {/* Patient Info */}
            <div style={{fontWeight:700,fontSize:13,color:'var(--ad-text-3)',textTransform:'uppercase',letterSpacing:.5,marginBottom:14,paddingBottom:8,borderBottom:'1px solid var(--ad-border)',marginTop:8}}>
              👤 Patient Information
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
              <WI_F label="First Name" req err={errors.firstName}>
                <input style={WI_inp(!!errors.firstName)} placeholder="First name" value={form.firstName} onChange={e=>this.setForm('firstName',e.target.value)} />
              </WI_F>
              <WI_F label="Last Name" req err={errors.lastName}>
                <input style={WI_inp(!!errors.lastName)} placeholder="Last name" value={form.lastName} onChange={e=>this.setForm('lastName',e.target.value)} />
              </WI_F>
              <WI_F label="Date of Birth" req err={errors.dob}>
                <input type="date" style={WI_inp(!!errors.dob)} value={form.dob}
                  onChange={e=>{this.setForm('dob',e.target.value);}} />
              </WI_F>
              <WI_F label="Gender" req err={errors.gender}>
                <select style={WI_sel(!!errors.gender)} value={form.gender} onChange={e=>this.setForm('gender',e.target.value)}>
                  <option value="">Select gender</option>
                  <option>Male</option><option>Female</option><option>Other</option>
                </select>
              </WI_F>
              <WI_F label="Blood Group">
                <select style={WI_sel(false)} value={form.bloodGroup} onChange={e=>this.setForm('bloodGroup',e.target.value)}>
                  <option value="">Select</option>
                  {BG.map(b=><option key={b}>{b}</option>)}
                </select>
              </WI_F>
              <WI_F label="Mobile" req err={errors.mobile}>
                <input type="tel" style={WI_inp(!!errors.mobile)} maxLength={10} placeholder="10-digit mobile" value={form.mobile} onChange={e=>this.setForm('mobile',e.target.value)} />
              </WI_F>
              <WI_F label="Email" style={{gridColumn:'1/-1'}}>
                <input type="email" style={WI_inp(false)} placeholder="patient@email.com" value={form.email} onChange={e=>this.setForm('email',e.target.value)} />
              </WI_F>
            </div>

            <div style={{display:'flex',justifyContent:'flex-end',marginTop:8}}>
              <button disabled={bookingLoading}
                onClick={()=>this.book(false)}
                style={{padding:'12px 32px',borderRadius:10,border:'none',background:'var(--ad-brand)',color:'#fff',fontSize:15,fontWeight:700,cursor:'pointer',fontFamily:'inherit',opacity:bookingLoading?0.6:1,display:'flex',alignItems:'center',gap:8}}>
                {bookingLoading ? 'Registering…' : `✓ Register Patient · ₹${form.doctor?.fees||'500'}`}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


function PlaceholderPage({ title, icon }) {
  return (
    <div>
      <div className="ad-page-header ad-fade-up"><h1 className="ad-page-title">{title}</h1></div>
      <div className="ad-card ad-fade-up-1">
        <div className="ad-coming-soon">
          <Ico name={icon} size={48} color="var(--ad-text-3)" />
          <h2>{title}</h2>
          <p>This section is coming soon.</p>
        </div>
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   BOTTOM NAV
════════════════════════════════════════════════════════════ */
class BottomNav extends Component {
  render() {
    const { activePage, onNav } = this.props;
    const ITEMS = [
      { id:"dashboard",    icon:"home",     label:"Home"     },
      { id:"appointments", icon:"calendar", label:"Appts"    },
      { id:"patients",     icon:"user",     label:"Patients" },
      { id:"doctors",      icon:"doctor2",  label:"Doctors"  },
    ];
    return (
      <nav className="ad-bottom-nav">
        {ITEMS.map(item=>(
          <button key={item.id}
            className={`ad-bottom-btn${activePage===item.id?" active":""}`}
            onClick={()=>onNav(item.id)}>
            <Ico name={item.icon} size={20} color={activePage===item.id?"var(--ad-brand)":"var(--ad-text-3)"} />
            {item.label}
          </button>
        ))}
      </nav>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   ADMIN DASHBOARD ROOT
════════════════════════════════════════════════════════════ */
/* ── Time Slot form helpers ── module level to prevent focus loss ── */
function TS_F({label, req, err, children}) {
  return (
    <div style={{marginBottom:14}}>
      <label style={{fontSize:12,fontWeight:600,color:'var(--ad-text-2)',display:'block',marginBottom:5,textTransform:'uppercase',letterSpacing:.5}}>
        {label}{req&&<span style={{color:'#ef4444',marginLeft:2}}>*</span>}
      </label>
      {children}
      {err && <div style={{fontSize:11,color:'#ef4444',marginTop:3}}>{err}</div>}
    </div>
  );
}
const TS_iS = (err) => ({width:'100%',height:42,borderRadius:10,border:`1.5px solid ${err?'#ef4444':'var(--ad-border)'}`,padding:'0 12px',fontSize:14,fontFamily:'inherit',outline:'none',boxSizing:'border-box'});
const TS_sS = (err) => ({...TS_iS(err),background:'#fff'});

class TimeSlotsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slots: [], loading: true, error: null,
      showModal: false,
      saving: false, saveError: null, saveSuccess: false,
      deleting: null,
      form: { doctorId:'', slotTime:'', noOfPatient:'30', status:'Active', startDate:'', endDate:'' },
      formErrors: {},
      doctors: [],
    };
  }

  componentDidMount() { this.fetchSlots(); this.fetchDoctors(); }

  async fetchDoctors() {
    try {
      const res  = await getRequest(API_ENDPOINTS.DOCTOR_LIST);
      const data = await res.json();
      let rows = [];
      if (Array.isArray(data.data?.Doctor))               rows = data.data.Doctor;
      else if (data.status && Array.isArray(data.data?.[0])) rows = data.data[0];
      else if (Array.isArray(data.data))                  rows = data.data;
      this.setState({ doctors: rows });
    } catch(e) {}
  }

  async fetchSlots() {
    this.setState({ loading: true, error: null });
    try {
      const res  = await getRequest(API_ENDPOINTS.TIME_SLOT_LIST);
      const data = await res.json();
      console.log('Time slots response:', data);
      let rows = [];
      if (data.status && Array.isArray(data.data)) rows = data.data;
      else if (Array.isArray(data.data?.[0]))       rows = data.data[0];
      else if (Array.isArray(data))                 rows = data;
      this.setState({ slots: rows, loading: false });
    } catch(err) {
      this.setState({ loading: false, error: err.message });
    }
  }

  setForm(k, v) {
    this.setState(s => ({ form: {...s.form, [k]: v}, formErrors: {...s.formErrors, [k]: ''} }));
  }

  async saveSlot() {
    const { form } = this.state;
    const e = {};
    if (!form.doctorId)     e.doctorId  = 'Required';
    if (!form.slotTime)     e.slotTime  = 'Required';
    if (!form.duration)     e.duration  = 'Required';

    const raw = localStorage.getItem("dg_user");
      
    const u = JSON.parse(raw);
    try {
      const payload = {
        DoctorID:       form.doctorId,
        TimeSlot:       form.slotTime,
        No_of_Patient:  form.noOfPatient || 30,
        CreatedBy:      u.personId

      };
      console.log('Add time slot payload:', payload);
      const res  = await postRequest(API_ENDPOINTS.TIME_SLOT_ADD, payload);
      const data = await res.json();
      console.log('Add time slot response:', data);
      if (data.status === false) { this.setState({ saving: false, saveError: data.message || 'Failed to add slot' }); return; }
      this.setState({ saving: false, saveSuccess: true });
      setTimeout(() => {
        this.setState({ showModal: false, saveSuccess: false, form: { doctorId:'', slotTime:'', noOfPatient:'30', status:'Active', startDate:'', endDate:'' } });
        this.fetchSlots();
      }, 1200);
    } catch(err) {
      this.setState({ saving: false, saveError: err.message });
    }
  }

  async deleteSlot(id,status) {
    var sendstatus = ""
    if(status == "Active"){
      sendstatus = "InActive"
    }else{
      sendstatus = "Active"
    }

    const payload = {
        DTSID:       id,
        Status:       sendstatus,
       
      };

    try {
      const res  = await postRequest(API_ENDPOINTS.TIME_SLOT_UPDATE_STATUS,  payload );
      const data = await res.json();
      if (data.status !== false) this.fetchSlots();
    } catch(e) {}
    this.setState({ deleting: null });
  }

  render() {
    const { slots, loading, error, showModal, saving, saveError, saveSuccess, form, formErrors, doctors, deleting } = this.state;

    // Format time "09:00:00" → "09:00 AM"
    const fmtTime = t => {
      if (!t) return '—';
      try {
        const [h,m] = t.split(':').map(Number);
        const ampm = h >= 12 ? 'PM' : 'AM';
        return `${h > 12 ? h-12 : h||12}:${String(m).padStart(2,'0')} ${ampm}`;
      } catch(_) { return t; }
    };

    return (
      <div>
        {/* Header */}
        <div className="ad-page-header ad-fade-up" style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',flexWrap:'wrap',gap:12}}>
          <div>
            <h1 className="ad-page-title">Time Slots</h1>
            <p className="ad-page-sub">{loading ? 'Loading…' : `${slots.length} slot${slots.length!==1?'s':''} configured`}</p>
          </div>
          <button className="ad-btn-add-doc" onClick={()=>this.setState({showModal:true,saveError:null,saveSuccess:false,formErrors:{}})}>
            <Ico name="plus" size={16} color="#fff" /> Add Time Slot
          </button>
        </div>

        {/* Add Modal */}
        {showModal && (
          <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}
            onClick={e=>{if(e.target===e.currentTarget)this.setState({showModal:false})}}>
            <div style={{background:'#fff',borderRadius:20,width:'100%',maxWidth:480,maxHeight:'90vh',overflowY:'auto',boxShadow:'0 20px 60px rgba(0,0,0,.2)'}}>
              {/* Modal header */}
              <div style={{padding:'20px 24px',borderBottom:'1px solid var(--ad-border)',display:'flex',alignItems:'center',justifyContent:'space-between',position:'sticky',top:0,background:'#fff',borderRadius:'20px 20px 0 0',zIndex:1}}>
                <div>
                  <div style={{fontWeight:800,fontSize:17,color:'var(--ad-text-1)'}}>Add Time Slot</div>
                  <div style={{fontSize:12,color:'var(--ad-text-3)',marginTop:2}}>Configure a new appointment time slot</div>
                </div>
                <button onClick={()=>this.setState({showModal:false})} style={{width:32,height:32,borderRadius:8,border:'1.5px solid var(--ad-border)',background:'#fff',cursor:'pointer',fontSize:18,color:'var(--ad-text-3)'}}>✕</button>
              </div>
              {/* Modal body */}
              <div style={{padding:24}}>
                {saveSuccess && <div style={{background:'#F0FDF4',border:'1px solid #a7f3d0',borderRadius:12,padding:'12px 16px',marginBottom:16,fontSize:14,color:'#059669',fontWeight:600}}>✓ Time slot added successfully!</div>}
                {saveError  && <div style={{background:'#FFF0EB',border:'1px solid #fcd9c4',borderRadius:12,padding:'12px 16px',marginBottom:16,fontSize:13,color:'#ef4444'}}>{saveError}</div>}

                <TS_F label="Doctor" req err={formErrors.doctorId}>
                  <select style={TS_sS(!!formErrors.doctorId)} value={form.doctorId} onChange={e=>this.setForm('doctorId',e.target.value)}>
                    <option value="">— Select Doctor —</option>
                    {doctors.map((d,i) => (
                      <option key={d.DoctorID||i} value={String(d.DoctorID||i)}>
                        Dr. {d.FirstName||''} {d.LastName||''} — {d.DepartmentName||''}
                      </option>
                    ))}
                  </select>
                </TS_F>

                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                  <TS_F label="Time Slot" req err={formErrors.slotTime}>
                    <input type="text" style={TS_iS(!!formErrors.slotTime)} value={form.slotTime} onChange={e=>this.setForm('slotTime',e.target.value)} />
                  </TS_F>
                  <TS_F label="Max Patients">
                    <input type="number" style={TS_iS(false)} placeholder="30" value={form.noOfPatient} onChange={e=>this.setForm('noOfPatient',e.target.value)} />
                  </TS_F>
                 
                </div>
              </div>
              {/* Modal footer */}
              <div style={{padding:'16px 24px',borderTop:'1px solid var(--ad-border)',display:'flex',justifyContent:'flex-end',gap:10,position:'sticky',bottom:0,background:'#fff',borderRadius:'0 0 20px 20px'}}>
                <button onClick={()=>this.setState({showModal:false})} style={{padding:'10px 24px',borderRadius:10,border:'1.5px solid var(--ad-border)',background:'#fff',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:'inherit',color:'var(--ad-text-1)'}}>Cancel</button>
                <button onClick={()=>this.saveSlot()} disabled={saving}
                  style={{padding:'10px 28px',borderRadius:10,border:'none',background:'var(--ad-brand)',color:'#fff',fontSize:14,fontWeight:700,cursor:'pointer',fontFamily:'inherit',opacity:saving?0.7:1}}>
                  {saving ? 'Saving…' : '+ Add Slot'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Slots list */}
        <div className="ad-card ad-fade-up-1">
          {loading && (
            <div style={{padding:32,textAlign:'center',color:'var(--ad-text-3)'}}>
              <Ico name="clock" size={32} color="var(--ad-border)" />
              <div style={{marginTop:10,fontSize:13}}>Loading time slots…</div>
            </div>
          )}
          {!loading && error && (
            <div style={{padding:24,textAlign:'center',color:'#FF6B35',fontSize:13}}>
              <Ico name="alert" size={20} color="#FF6B35" />
              <div style={{marginTop:8}}>Could not load slots — {error}</div>
              <button onClick={()=>this.fetchSlots()} style={{marginTop:12,padding:'8px 18px',borderRadius:10,border:'1.5px solid var(--ad-border)',background:'#fff',cursor:'pointer',fontSize:13,fontWeight:600,fontFamily:'inherit'}}>↺ Retry</button>
            </div>
          )}
          {!loading && !error && slots.length === 0 && (
            <div style={{padding:40,textAlign:'center',color:'var(--ad-text-3)'}}>
              <Ico name="clock" size={36} color="var(--ad-border)" />
              <div style={{marginTop:12,fontSize:14,fontWeight:600,color:'var(--ad-text-2)'}}>No time slots configured</div>
              <div style={{fontSize:13,marginTop:4}}>Click "+ Add Time Slot" to create one</div>
            </div>
          )}
          {!loading && slots.length > 0 && (
            <div style={{overflowX:'auto'}}>
              <table className="ad-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Doctor</th>
                    <th>Time</th>
                    <th>Max Patients</th>
                   
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {slots.map((s, i) => {
                    const slotId     = s.DTSID || s.id || i;
                    const doctorName = `Dr. ${s.FirstName||''} ${s.LastName||''}`.trim() || `Doctor #${s.DoctorID}`;
                    const dept       = s.DepartmentName || '—';
                    const isActive   = (s.timeslotStatus||'active').toLowerCase() === 'active';
                    const fmtD       = iso => iso ? new Date(iso).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'}) : '—';
                    return (
                      <tr key={slotId}>
                        <td style={{fontFamily:'monospace',color:'var(--ad-brand)',fontWeight:700,fontSize:12}}>#{slotId}</td>
                        <td>
                          <div style={{fontWeight:600,fontSize:13}}>{doctorName}</div>
                          <div style={{fontSize:11,color:'var(--ad-text-3)'}}>{dept}</div>
                        </td>
                        <td>
                          <span style={{background:'#E8F1FF',color:'#0A6EFF',fontWeight:700,fontSize:12,padding:'4px 10px',borderRadius:20}}>
                            {s.TimeSlot || '—'}
                          </span>
                        </td>
                        <td style={{color:'var(--ad-text-2)',fontSize:13}}>{s.No_of_Patient||'—'}</td>
                    
                        <td>
                          <span style={{fontSize:11,fontWeight:700,padding:'3px 10px',borderRadius:20,background:isActive?'var(--ad-accent-light)':'#F1F5F9',color:isActive?'#059669':'var(--ad-text-3)'}}>
                            {s.timeslotStatus}
                          </span>
                        </td>
                        <td>
                          <button onClick={()=>this.deleteSlot(slotId,s.timeslotStatus)} 
                            style={{padding:'5px 12px',borderRadius:8,border:'1.5px solid #fcd9c4',background:'#FFF0EB',color:'#FF6B35',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:'inherit',opacity:deleting===slotId?0.6:1}}>
                            Change Status
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const PAGE_META = {
  dashboard:    { title:"Dashboard",    subtitle:"Hospital overview & stats"  },
  walkin:       { title:"Walk-in Registration", subtitle:"Register a walk-in patient" },
  appointments: { title:"Appointments", subtitle:"All appointment records"     },
  patients:     { title:"Patients",     subtitle:"Patient management"          },
  doctors:      { title:"Doctors",      subtitle:"Medical staff management"    },
  timeslots:    { title:"Time Slots",   subtitle:"Manage appointment time slots" },
  reports:      { title:"Reports",      subtitle:"Analytics & reports"         },
  settings:     { title:"Settings",     subtitle:"System configuration"        },
};

export class AdminDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = { activePage:"dashboard", sidebarOpen:false };
  }
  setPage(page)   { this.setState({ activePage:page, sidebarOpen:false }); }
  toggleSidebar() { this.setState(s=>({ sidebarOpen:!s.sidebarOpen })); }

  renderPage() {
    switch(this.state.activePage) {
      case "dashboard":    return <DashboardPage onNav={p=>this.setPage(p)} />;
      case "walkin":       return <WalkInPage />;
      case "appointments": return <AdminAppointmentsPage />;
      case "patients":     return <PatientsPage />;
      case "doctors":      return <DoctorsPage />;
      case "timeslots":    return <TimeSlotsPage />;

      case "settings":     return <PlaceholderPage title="Settings" icon="settings" />;
      default:             return <DashboardPage />;
    }
  }

  render() {
    const { activePage, sidebarOpen } = this.state;
    const { onLogout } = this.props;
    const meta = PAGE_META[activePage]||PAGE_META["dashboard"];
    return (
      <div className="ad-shell">
        <Sidebar activePage={activePage} onNav={p=>this.setPage(p)}
          isOpen={sidebarOpen} onClose={()=>this.setState({sidebarOpen:false})} onLogout={onLogout} />
        <div className="ad-main">
          <Header title={meta.title} subtitle={meta.subtitle} onMenuClick={()=>this.toggleSidebar()} />
          <main className="ad-content">{this.renderPage()}</main>
        </div>
        <BottomNav activePage={activePage} onNav={p=>this.setPage(p)} />
      </div>
    );
  }
}

export default AdminDashboard;